import React, { useState, useEffect, useRef } from 'react';
import '../catalogue/styles.css';
import { Link, useNavigate } from 'react-router-dom';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import globalIP from '../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import EditIcon from '@rsuite/icons/Edit';
import AddRemoveProductModal from '@/components/AddRemoveProductModal';
import CloseOutlineIcon from '@rsuite/icons/CloseOutline';
import RemindIcon from '@rsuite/icons/legacy/Remind';
import MenuIcon from '@rsuite/icons/Menu';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import ReviewRefuseIcon from '@rsuite/icons/ReviewRefuse';
import ReviewPassIcon from '@rsuite/icons/ReviewPass';
import {
  Button,
  Pagination,
  Form,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  TagPicker,
  Container,
  Modal,
  IconButton,
  Table,
  CellProps,
  Dropdown,
  Input,
  SelectPicker,
  FlexboxGrid,
  Col,
  Message,
  useToaster,
  Tooltip,
  Whisper,
  InputNumber,
  InputPicker
} from 'rsuite';
import {
  fetchColors,
  fetchFinishes,
  fetchCategory,
  fetchBuyers,
  fetchProductLabel,
  fetchProductTypes,
  fetchCurrency,
  fetchHsn,
  fetchMaterials,
  fetchMaterialCollection,
  fetchSkuUnique,
  fetchAlias,
  fetchMadeBy,
  fetchHeads,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchComponent,
  fetchShape,
  fetchSeason,
  fetchPtechnique
} from '../.././apiService/apiService';
import { Icon } from '@rsuite/icons';
import TrashIcon from '@rsuite/icons/Trash';
import SendIcon from '@rsuite/icons/Send';
import ProjectIcon from '@rsuite/icons/Project';
import { useLocation } from 'react-router-dom';
import TreemapIcon from '@rsuite/icons/Treemap';
import useUser from '../../components/UseUser';

interface RowDataForCompany {
  id: string; // or number, depending on your data
  attributes: {
    buyercode: string;
    companynm: string;
    buyernm: string;
    country: string;
    email: string;
    address: string;
    contactno: string;
    merchantnm: string;
    // Add other attributes if needed
  };
}
interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    ProductTypeCode: string;
    ProductCode: string;
    ProductId: string;
    ProductName: string;
    Description: string;
    SizeUnit: string;
    Length: 0;
    Width: 0;
    Height: 0;
    FinishCode: null;
    ColorCode: null;
    NetWeight: 0;
    GrossWeight: 0;
    HSNCode: string;
    SellingPriceCurrency: string;
    SellingPriceUnit: string;
    SellingPrice: 0;
    ProductCost: 0;
    SearchKeyword: string;
    MOQ: string;
    ProductDesigner: null;
    MadeBy: null;
    CategoryName: string;
    ProductTypeName: null;
    cbm: null;
    FinishName: null;
    ColorName: null;
    BuyerName: null;
    BuyerSku: null;
    SizeRange: null;
    Total_CBM: null;
    Total_CFT: null;
    TwentyFT: null;
    FortyFT: null;
    FortyHQ: null;
    SetSizes: null;
    Product_Remark: string;
    Variant_Id: string;
    CoverImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    MultipleImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    ProductionDetail: [
      {
        id: string;
        ProductCode: string;
        MaterialNm: string;
        MaterialFinishNm: string;
        MatNetWeight: 0;
        MaterialCode: string;
        MaterialFinishCode: string;
      }
    ];
    // Add other attributes if needed
    Packaging: [
      {
        id: string;
        CartonType: string;
        ProductCode: string;
        Carton_Unit: string;
        Carton_Length: 0;
        Carton_Width: 0;
        Carton_Thick: 0;
        Carton_CBM: 0;
        Carton_PCS: 0;
        Carton_CBMperpc: 0;
        Carton_GrsWt: 0;
      }
    ];
  };
}

type YourDataType = {
  id: number;
  attributes: {
    CoverImage: any;
    ProductName: string;
    ProductId: string;
    ProductTypeName: string;
    SizeUnit: string;
    Length: number;
    Width: number;
    Height: number;
    Color: string;
    Finish: string;
    cbm: number;
    CategoryCode: string;
    CategoryName: string;
    ProductTypeCode: string;
    Description: string;
    FinishName: string;
    ColorName: string;
    NetWeight: number;
    GrossWeight: number;
    SellingPrice: number;
    SellingPriceCurrency: string;
    Product_Remark: string;
    shape: string;
    Total_CBM: number;
    SizeRange: string;

    // Add other attribute properties here
  };
};
import DrawerViewe from './DrawerViewe';
import DrawerLink from './DrawerLink';
import ugr from '@/UGRoute';
import axios from 'axios';
import Footer from '@/components/Footer/Footer';
import TableCustomizeDetails from '@/components/TableEditDetails/TableCustomizeDetails';
import ShowDimensionModal from '@/components/ShowDimensionModal';
import { CheckIcon, ImageIcon } from 'lucide-react';
const { Column, HeaderCell, Cell } = Table;

export const ImageCell = ({ rowData, dataKey, ...props }: CellProps) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div
      style={{
        width: 40,
        height: 40,
        background: '#f5f5f5',
        borderRadius: 6,
        marginTop: 2,
        overflow: 'hidden',
        display: 'inline-block'
      }}
    >
      <img src={rowData[dataKey!]} width="40" />
    </div>
  </Cell>
);

let catalogueCodeCounter = 1;
let CollectionCodeCounter = 1;

const cartontype = [
  { label: 'Master', value: 'master' },
  { label: 'Inner', value: 'inner' }
];

const siii = [
  { label: 'CM', value: 'cm' },
  { label: 'Inch', value: 'inch' }
];

const EditDetails = () => {
  const { user } = useUser();
  const dataFromSession = sessionStorage.getItem('fullName');
  const Name = JSON.parse(dataFromSession);
  const [show, setShow] = React.useState(true);
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const ipp = globalIP;
  const { Column, HeaderCell, Cell } = Table;
  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const [showIcon, setShowIcon] = useState(false);
  const handleToggleIcon = () => {
    setShowIcon(!showIcon);
  };

  const [opencbm, setOpencbm] = useState(false);
  const [cbmeditdata, setCbmEditData] = useState('');
  const [totalcbm1, setTotalCbm] = useState(0);
  const [totalcft, setTotalCFT] = useState(0);
  const [feet20, setFeet20] = useState<any | null>(0);
  const [feet40, setFeet40] = useState<any | null>(0);
  const [feet20hc, setFeet20hc] = useState<any | null>(0);
  const handleOpencbm = prcd => {
    setCbmEditData(prcd);
    setOpencbm(true);
  };
  const handleClosecbm = () => setOpencbm(false);
  const [finishdata, setFinishData] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  useEffect(() => {
    fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin);
  }, []);

  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, []);

  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchCategory(setCategorydata, isLoadingc, setIsLoadingc, setProgress);
  }, []);

  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    fetchProductTypes(setProductypedata, isLoadingpro, setIsLoadingpro);
  }, []);

  const [currencydata, setCurrencydata] = useState([]);
  const [isLoadingCurr, setIsLoadingCurr] = useState(false);
  useEffect(() => {
    fetchCurrency(setCurrencydata, isLoadingCurr, setIsLoadingCurr);
  }, []);
  const handleSizeChange = (selectedUnit, l, w, h, u, id, fieldName) => {
    const unit = convertDimensions(l, w, h, u, selectedUnit);
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (updatedData[id]) {
        updatedData[id].Length = unit[0];
        updatedData[id].Width = unit[1];
        updatedData[id].Height = unit[2];
      }
      updatedData[id][fieldName] = selectedUnit;
      return updatedData;
    });

  };
  const cmToInch = value => (value / 2.54).toFixed(2);
  const inchToCm = value => (value * 2.54).toFixed(2);

  const convertDimensions = (length, width, height, unit, sizeUnit) => {
    if (unit === 'inch' && sizeUnit === 'inch') {
      // return `${length}x${width}x${height} `;
      return [length, width, height];
    } else if (unit === 'cm' && sizeUnit === 'cm') {
      return [length, width, height];
      // return `${length}x${width}x${height} `;
    } else if (unit === 'inch' && sizeUnit === 'cm') {
      return [inchToCm(length), inchToCm(width), inchToCm(height)];
    } else if (unit === 'cm' && sizeUnit === 'inch') {
      return [cmToInch(length), cmToInch(width), cmToInch(height)];
    }
    return [length, width, height];
  };

  const [headerSizeUnit, setHeaderSizeUnit] = useState<string>('');
  const handleHeaderSelectChange = value => {
    setHeaderSizeUnit(value);
    // Update SizeUnit for all rows
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      Object.keys(updatedData).forEach(rowId => {
        updatedData[rowId];
        if (updatedData[rowId]) {
          const l = updatedData[rowId].Length;
          const w = updatedData[rowId].Width;
          const h = updatedData[rowId].Height;
          const u = updatedData[rowId].SizeUnit;
          const unit = convertDimensions(l, w, h, u, value);
          // updatedData[rowId] =
          updatedData[rowId].Length = unit[0];
          updatedData[rowId].Width = unit[1];
          updatedData[rowId].Height = unit[2];
        }
        updatedData[rowId].SizeUnit = value;
      });
      return updatedData;
    });
  };
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchProductLabel(setLabel);
  }, []);

  const [sizeshow, setSizeShow] = useState(false);
  const [finShow, setFinShow] = useState(false);

  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
      setFinShow(json.data[0].attributes.setFinish);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [edit, setEdit] = useState(false);
  const [showDimm, setShowDimm] = React.useState(false);
  const [showDimm2, setShowDimm2] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowID, setSelectedRowID] = useState(null);

  const handleToggle = id => {
    let updatedRows = [...selectedRow];
    updatedRows[id].status = !updatedRows[id].status;
    setSelectedRow(updatedRows);
  };
  const handleOpenDimm = row => {
    setSelectedRow(row);
    setShowDimm(true);
  };
  const handleOpenDimm2 = row => {
    setSelectedRowID(row.id);
    if (Object.keys(editedData).length) {
      setSelectedRow(editedData[row.id]['SetSizes']);
    } else {
      setSelectedRow(row.attributes.SetSizes);
    }
    setShowDimm2(true);
  };
  const handleCloseDimm = () => setShowDimm(false);
  const handleCloseDimm2 = () => setShowDimm2(false);
  const handleInputChange4 = (value, rowData, field) => {
    let updatedData;
    if (field == 'ColorName') {
      const ColorCode = value;
      const ColorName = colordata.find(item => item.value == value).label;

      updatedData = selectedRow.map(item =>
        item.id === rowData.id
          ? { ...item, ['ColorCode']: ColorCode, ['ColorName']: ColorName }
          : item
      );
    } else {
      updatedData = selectedRow.map(item =>
        item.id === rowData.id ? { ...item, [field]: value } : item
      );
    }
    setSelectedRow(updatedData);
  };
  const saveDimmChange = () => {
    const rowId = selectedRowID;
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = {
          ProductName: '',
          Description: '',
          NetWeight: 0,
          GrossWeight: 0,
          Product_Remark: ''
        };
      }
      updatedData[rowId]['SetSizes'] = selectedRow;
      return updatedData;
    });
    handleCloseDimm2();
  };
  const [headerCurrency, setHeaderCurrency] = useState('');

  const handleHeaderCurrencyChange = (value) => {
    setHeaderCurrency(value);
    setEditedData(prevData => {
      const updatedData = { ...prevData };

      Object.keys(updatedData).forEach(rowId => {
        if (updatedData[rowId]) {
          const productCost = updatedData[rowId]?.ProductCost || 0;

          // Find selected currency's exchange rate
          const selectedCurrency = currencydata.find(item => item.label === value);

          if (selectedCurrency && productCost) {
            const exchangeRate = selectedCurrency.exchangerate;

            // Calculate selling price
            const calculatedSellingPrice = productCost / exchangeRate;

            updatedData[rowId].SellingPrice = calculatedSellingPrice.toFixed(2);
          }

          updatedData[rowId].SellingPriceCurrency = value; // Update currency for each row
        }
      });

      return updatedData;
    });
  };


  const defaultColumns = [
    {
      key: 'serialNumber',
      label: <b>Sr.No.</b>,
      fixed: true,
      align: 'center',
      width: 70
    },
    {
      key: 'Image',
      label: 'Image',
      width: 80,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell className="image-cell">
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }} className="img-hover">
                <img
                  src={imageSrc}
                  alt="Product Image"
                  style={{ width: 400, height: 400, objectFit: 'contain' }}
                />
              </Tooltip>
            );
            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${ipp}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`
                )}
              >
                <img
                  src={`${ipp}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, objectFit: 'contain' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'CategoryName',
      label: `${label[0]?.attributes.Category}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Category}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={categorydata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.CategoryName || ''}
                onChange={value =>
                  handleInputChange3(
                    rowData.id,
                    'CategoryName',
                    'CategoryCode',
                    value,
                    categorydata
                  )
                }
              />
            ) : (
              rowData.attributes.CategoryName
            )
          }
        </Cell>
      )
    },
    {
      key: 'ProducttypeName',
      label: `${label[0]?.attributes.ProductType}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductType}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={productypedata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.ProductTypeName || rowData.attributes.ProductTypeName}
                onChange={value =>
                  handleInputChange3(
                    rowData.id,
                    'ProductTypeName',
                    'ProductTypeCode',
                    value,
                    productypedata
                  )
                }
                searchable
                cleanable={false} // optional: prevents clearing the value accidentally
                placeholder="Select product type"
                renderMenuItem={(label, item) => (
                  <div>{label}</div>
                )}
              />
            ) : (
              rowData.attributes.ProductTypeName
            )
          }

        </Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductId" />
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductName || ''}
                onChange={value => handleInputChange2(rowData.id, 'ProductName', value)}
              />
            ) : (
              rowData.attributes.ProductName
            )
          }
        </Cell>
      )
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 200,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Description || ''}
                onChange={value => handleInputChange2(rowData.id, 'Description', value)}
              />
            ) : (
              rowData.attributes.Description
            )
          }
        </Cell>
      )
    },
    {
      key: 'Status',
      label: 'Set Status',
      //  `${label[0]?.attributes.SetStatus}`,
      width: 200,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>SetStatus</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const isEdited = editedRowIds.includes(rowData.id);

            // Check if SetStatus is 'Set'
            if (rowData.attributes.SetStatus === 'Set') {
              return (
                <Button
                  onClick={() =>
                    isEdited
                      ? handleOpenDimm2(rowData)
                      : handleOpenDimm(rowData.attributes.SetSizes)
                  }
                >
                  {isEdited ? 'Edit Size' : 'View Size'}
                </Button>
              );
            }

            // If SetStatus is not 'Set', just return the SetStatus value (or handle other cases)
            return rowData.attributes.SetStatus;
          }}
        </Cell>
      )
    },
    !sizeshow && {
      key: 'SizeUnit',
      label: 'Size Unit',
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: edit === true ? '10px' : '0', // Adjust margin based on edit state
              marginTop: '-2px',
              justifyContent: edit === true ? 'flex-start' : 'center' // Align items based on edit state
            }}
          >
            <b>Unit</b>
            {edit === true && (
              <SelectPicker
                data={siii}
                style={{ marginLeft: '8px' }}
                onChange={value => handleHeaderSelectChange(value)}
              />
            )}
          </div>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const l = rowData.attributes.Length;
            const width = rowData.attributes.Width;
            const h = rowData.attributes.Height;
            const u = rowData.attributes.SizeUnit;
            return editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={siii}
                value={editedData[rowData.id]?.SizeUnit || ''}
                onChange={value => {
                  handleSizeChange(value, l, width, h, u, rowData.id, 'SizeUnit');
                }}
              />
            ) : headerSizeUnit !== '' ? (
              headerSizeUnit
            ) : (
              rowData.attributes.SizeUnit
            );
          }}
        </Cell>
      )
    },
    !sizeshow && {
      key: 'Length',
      label: 'Length',
      width: 80,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{`${label[0]?.attributes.length}`}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const { Length, SetStatus, SetSizes } = rowData.attributes;
            const isEdited = editedRowIds.includes(rowData.id);
            return isEdited ? (
              <Input
                value={editedData[rowData.id]?.Length || ''}
                disabled={SetStatus == 'Set'}
                onChange={value => handleInputChange2(rowData.id, 'Length', value)}
              />
            ) : (
              <p>{Length}</p>
            );
          }}
        </Cell>
      )
    },
    !sizeshow && {
      key: 'Width',
      label: 'Width',
      width: 80,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{`${label[0]?.attributes.width}`}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const { Width, SetStatus, SetSizes } = rowData.attributes;
            const isEdited = editedRowIds.includes(rowData.id);
            return isEdited ? (
              <Input
                value={editedData[rowData.id]?.Width || ''}
                disabled={SetStatus == 'Set'}
                onChange={value => handleInputChange2(rowData.id, 'Width', value)}
              />
            ) : (
              <p>{Width}</p>
            );
          }}
        </Cell>
      )
    },
    !sizeshow && {
      key: 'Height',
      label: 'Height',
      width: 80,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{`${label[0]?.attributes.height}`}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const { Height, SetStatus, SetSizes } = rowData.attributes;
            const isEdited = editedRowIds.includes(rowData.id);
            return isEdited ? (
              <Input
                value={editedData[rowData.id]?.Height || ''}
                disabled={SetStatus == 'Set'}
                onChange={value => handleInputChange2(rowData.id, 'Height', value)}
              />
            ) : (
              <p>{Height}</p>
            );
          }}
        </Cell>
      )
    },

    sizeshow && {
      key: 'SizeRange',
      label: `${label[0]?.attributes.SizeRange}`,
      width: 80,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.SizeRange}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.SizeRange || ''}
                onChange={value => handleInputChange2(rowData.id, 'SizeRange', value)}
              />
            ) : (
              rowData.attributes.SizeRange
            )
          }
        </Cell>
      )
    },

    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={finishdata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.FinishName || ''}
                onChange={value =>
                  handleInputChange3(rowData.id, 'FinishName', 'FinishCode', value, finishdata)
                }
                style={{ width: 250 }} // Width of the picker input box
                menuStyle={{
                  maxHeight: 200,      // Scrollable dropdown
                  overflowY: 'auto',
                  minWidth: 150,        // Minimum menu width
                  width: 250        // Let menu auto-size to content if needed
                }}
                searchable
                placement="bottomEnd"
              />
            ) : (
              rowData.attributes.FinishName
            )
          }
        </Cell>
      )
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={colordata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.ColorName || ''}
                onChange={value =>
                  handleInputChange3(rowData.id, 'ColorName', 'ColorCode', value, colordata)
                }
                style={{ width: 250 }} // Width of the picker input box
                menuStyle={{
                  maxHeight: 200,      // Scrollable dropdown
                  overflowY: 'auto',
                  minWidth: 150,        // Minimum menu width
                  width: 250        // Let menu auto-size to content if needed
                }}
                searchable
                placement="bottomEnd"
              />
            ) : (
              rowData.attributes.ColorName
            )
          }
        </Cell>
      )
    },
    {
      key: 'NetWt',
      label: `${label[0]?.attributes.NetWgt}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.NetWgt}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <InputNumber
                value={editedData[rowData.id]?.NetWeight || ''}
                onChange={value => handleInputChange2(rowData.id, 'NetWeight', value)}
              />
            ) : (
              rowData.attributes.NetWeight
            )
          }
        </Cell>
      )
    },
    {
      key: 'GrossWt',
      label: `${label[0]?.attributes.GrossWgt}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.GrossWgt}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <InputNumber
                value={editedData[rowData.id]?.GrossWeight || ''}
                onChange={value => handleInputChange2(rowData.id, 'GrossWeight', value)}
              />
            ) : (
              rowData.attributes.GrossWeight
            )
          }
        </Cell>
      )
    },
    {
      key: 'Currency',
      label: 'Currency',
      width: 160,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: edit === true ? '0' : '0',
              marginTop: '-2px',
              justifyContent: edit === true ? 'flex-start' : 'center'
            }}
          >
            <b>Currency</b>
            {edit === true && (
              <SelectPicker
                data={currencydata}
                style={{ marginLeft: '8px', width: 100 }}
                onChange={value => handleHeaderCurrencyChange(value)}
              />
            )}
          </div>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData => {
            const isEdited = editedRowIds.includes(rowData.id);
            return isEdited ? (
              <SelectPicker
                data={currencydata}
                value={editedData[rowData.id]?.SellingPriceCurrency || ''}
                onChange={value => handleInputChange2(rowData.id, 'SellingPriceCurrency', value)}
              />
            ) : headerCurrency !== '' ? (
              headerCurrency
            ) : (
              rowData.attributes.SellingPriceCurrency
            );
          }}
        </Cell>
      )
    },
    {
      key: 'salepri',
      label: `${label[0]?.attributes.SalePrice}`, // Adjust label as needed
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.SalePrice}</b> {/* Adjust label as needed */}
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id)
              ? editedData[rowData.id]?.SellingPrice || rowData.attributes.SellingPrice
              : rowData.attributes.SellingPrice
          }
        </Cell>
      )
    },
    {
      key: 'ProductCost',
      label: `${label[0]?.attributes.SalePriceINR}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.SalePriceINR}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductCost" />
    },
    {
      key: 'ProductR',
      label: `${label[0]?.attributes.ProductRemark}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductRemark}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Product_Remark || ''}
                onChange={value => handleInputChange2(rowData.id, 'Product_Remark', value)}
              />
            ) : (
              rowData.attributes.Product_Remark
            )
          }
        </Cell>
      )
    },
    {
      key: 'cbm',
      label: `${label[0]?.attributes.cbm}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
            <b>{label[0]?.attributes.cbm}</b>
            <div
              onClick={handleToggleIcon}
              style={{ marginLeft: '5px', fontSize: '15px', cursor: 'pointer' }}
            >
              {showIcon ? <Icon as={CloseOutlineIcon} /> : <Icon as={EditIcon} />}
            </div>
          </div>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell dataKey="attributes.Total_CBM">
          {rowData => (
            <div>
              {rowData.attributes.Packaging?.reduce((total, carton) => total + (carton.Carton_CBM || 0), 0).toFixed(3)}
              {showIcon && (
                <IconButton
                  icon={<EditIcon />}
                  circle
                  size="xs"
                  style={{ marginLeft: '5px' }}
                  onClick={() => handleOpencbm(rowData.id)}
                />
              )}
            </div>
          )}
        </Table.Cell>
      )
    },
    {
      key: 'Action',
      label: 'Action',
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell style={{ padding: '6px' }}>
          {rowData =>
            data1234.length > 1 && ( // Check if more than one row exists
              <IconButton
                size="sm"
                icon={<TrashIcon />}
                active
                onClick={() => handleDeleteRow(rowData.id)}
              />
            )
          }
        </Table.Cell>
      )
    }
  ].filter(Boolean);

  const toaster = useToaster();
  const [open5, setOpen5] = React.useState(false);
  const handleOpen5 = () => setOpen5(true);
  const handleClose5 = () => {
    setOpen5(false);
  };
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => {
    setOpen1(false);
  };
  const [open4, setOpen4] = React.useState(false);
  const handleOpen4 = () => setOpen4(true);
  const handleClose4 = () => setOpen4(false);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open3, setOpen3] = React.useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => {
    setOpen3(false);
  };
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    setOpen2(false);
  };
  const ip = ipp;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const [updateCatalogue, setUpdateCatalogue] = useState(searchParams.get('updateCatalogue'));

  const selectedItemsArray = selectedItems.split(',');
  const [showDrawer2, setShowDrawer2] = useState(false);
  const [showDrawer3, setShowDrawer3] = useState(false);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = React.useState(false);
  const [columnKeys, setColumnKeys] = React.useState(
    defaultColumns
      .map(column => column.key)
    // .filter(key => key !== 'ProductCost' && key !== 'Currency')
  );
  const CustomCell = CompactCell;
  const CustomHeaderCell = CompactHeaderCell;
  const [selectedAttributes, setSelectedAttributes] = useState();
  useEffect(() => {
    if (columnKeys.length) {
      const updatedAttributes = {
        Cust_Aliascode: columnKeys.includes('ProductId'),
        Cust_Productname: columnKeys.includes('ProductName'),
        Cust_Description: columnKeys.includes('Description'),
        Cust_Producttype: columnKeys.includes('ProducttypeName'),
        Cust_Category: columnKeys.includes('CategoryName'),
        Cust_Finish: columnKeys.includes('FinishName'),
        Cust_Color: columnKeys.includes('ColorName'),
        Cust_NetWgt: columnKeys.includes('NetWt'),
        Cust_GrsWgt: columnKeys.includes('GrossWt'),
        Cust_SalePrice: columnKeys.includes('ProductCost'),
        Cust_CBM: columnKeys.includes('cbm'),
        Cust_Unit: columnKeys.includes('SizeUnit'),
        Cust_FreeSize: columnKeys.includes('SizeRange')
      };
      setSelectedAttributes(updatedAttributes);
    }
  }, [columnKeys]);
  useEffect(() => {
    setColumnKeys(previousKeys => {
      if (sizeshow) {
        return [...previousKeys, 'SizeRange'];
      } else {
        return previousKeys.filter(key => key !== 'SizeRange');
      }
    });
  }, [sizeshow]);

  // Fetch Data from API Start
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [data1234, setData1234] = useState<YourDataType[]>([]);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    fetchAndProcessCatalogueData();
  }, [isDataFetched]);
  const [searchProductId, setSearchProductId] = useState(''); // user typed value
  useEffect(() => {
    fetchData();
  }, [searchProductId]);

  const fetchData = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const selectedItems = searchParams.get('selectedItems') || '';      // could be products or mixed
    const selectedVarItems = searchParams.get('selectedVarItems') || ''; // optional old format
    const updateCatalogue = searchParams.get('updateCatalogue') || '';

    // Split IDs into arrays
    const selectedItemsArray = selectedItems.split(',').filter(id => id);
    const selectedVarItemsArray = selectedVarItems.split(',').filter(id => id);

    setProgress(30);
    setLoading(true);

    const allProducts = [];
    const allVariants = [];

    // --- Fetch products ---
    if (selectedItemsArray.length > 0) {
      const productFilter = selectedItemsArray.map(id => `filters[id][$eq]=${id}`).join('&');

      // First page to get pagination info
      const firstPageResponse = await fetch(
        `${ipp}/api/products?${productFilter}&populate=*&filters[Authorized][$eq]=Authorised&pagination[page]=1`
      );
      const firstPageJson = await firstPageResponse.json();

      for (let page = 1; page <= firstPageJson.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ipp}/api/products?${productFilter}&populate=*&filters[Authorized][$eq]=Authorised&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        allProducts.push(...pageJson.data);
      }
    }

    // --- Fetch variants ---

    // Case 1: Old format has selectedVarItems
    if (selectedVarItemsArray.length > 0) {
      const variantFilter = selectedVarItemsArray.map(id => `filters[id][$eq]=${id}`).join('&');
      const variantResponse = await fetch(`${ipp}/api/variant-products?${variantFilter}&populate=*`);
      const variantJson = await variantResponse.json();
      allVariants.push(...variantJson.data);
    }

    // Case 2: New format: all IDs in selectedItems, some not found in products = variants
    if (selectedVarItemsArray.length === 0 && selectedItemsArray.length > 0) {
      const fetchedProductIds = allProducts.map(item => item.id.toString());
      const variantIds = selectedItemsArray.filter(id => !fetchedProductIds.includes(id));

      if (variantIds.length > 0) {
        const variantFilter = variantIds.map(id => `filters[id][$eq]=${id}`).join('&');
        const variantResponse = await fetch(`${ipp}/api/variant-products?${variantFilter}&populate=*`);
        const variantJson = await variantResponse.json();
        allVariants.push(...variantJson.data);
      }
    }

    // --- Combine products and variants ---
    const combinedData = [...allProducts, ...allVariants];

    // Mark SetSizes as status=true for sets
    combinedData.forEach(item => {
      if (item.attributes.SetStatus === 'Set') {
        item.attributes.SetSizes.forEach(setSize => {
          setSize.status = true;
        });
      }
    });
    let filteredData = combinedData;
    if (searchProductId.trim() !== '') {
      filteredData = combinedData.filter(item =>
        item.attributes.ProductId
          .toString()
          .toLowerCase()
          .includes(searchProductId.trim().toLowerCase())
      );
    }

    setData1234(filteredData);
    setLoading(false);
    setProgress(100);
    setIsDataFetched(true);

    console.log('Products + Variants:', combinedData);
  };


  //  Fetch Data from API End
  const [currentPage, setCurrentPage] = useState(1);
  const dataWithSerialNumbers = data1234
    .slice()
    .reverse()
    .sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
    .map((item, index) => ({
      ...item,
      serialNumber: index + 1
    }));

  // Slice the data for the current page
  const paginatedData = dataWithSerialNumbers.slice((currentPage - 1) * 10, currentPage * 10);
  const handleDeleteRow = id => {
    // Remove the row from the data
    setData1234(prevData => prevData.filter(item => item.id !== id));

    // Remove the ID from URL params
    const searchParams = new URLSearchParams(window.location.search);
    const selectedItems = searchParams.get('selectedItems');

    if (selectedItems) {
      const selectedItemsArray = selectedItems.split(',').map(Number); // Convert to numbers
      const updatedSelectedItems = selectedItemsArray.filter(itemId => itemId !== id);
      const updatedSelectedItemsString = updatedSelectedItems.join(',');

      // Update URL params
      if (updatedSelectedItems.length > 0) {
        searchParams.set('selectedItems', updatedSelectedItemsString);
      } else {
        searchParams.delete('selectedItems'); // Remove the param if no IDs left
      }

      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.pushState({}, '', newUrl);
    }
  };

  const [coll, setColl] = useState({
    CollectionName: '',
    BuyerCompany: '',
    BuyerEmail: '',
    CollectionCode: '',
    BuyerName: '',
    CollectionProduct: [
      {
        ColProduct: '',
        CollectionCode: ''
      }
    ]
  });
  const GotoProductDesignwithId = useNavigate();
  const uddateProduct = data => {
    if (cata.catalogueName === '') {
    } else {
      const encodedData = encodeURIComponent(JSON.stringify(data));
      if (user.CATaccessPPT === true || user.Category === 'Admin') {
        GotoProductDesignwithId(
          `/${ugr}/generate-catalogue1?cataloguename=${cata.catalogueName
          }&cataloguecode=${generateCatalogue()}&buyername=${cata.BuyerName}`
        );
      } else {
        GotoProductDesignwithId(
          `/${ugr}/manageCatalogue`
        )
      }
    }
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };
  const GotoProductDesignwithIdc = useNavigate();
  const uddateProductc = (data, collectionData) => {
    if (!collectionData) return;
    const collectionName = collectionData.attributes?.CollectionName;
    const collectionCode = collectionData.attributes?.CollectionCode;
    const buyerName = collectionData.attributes?.BuyerName || "";
    GotoProductDesignwithIdc(
      `/${ugr}/generate-collection?collectionname=${encodeURIComponent(collectionName)}&collectioncode=${encodeURIComponent(collectionCode)}&buyername=${encodeURIComponent(buyerName)}`
    );
  };

  const [cata, setCata] = useState({
    catalogueName: '',
    BuyerCompany: '',
    BuyerEmail: '',
    CatalogueCode: '',
    BuyerName: '',
    Status: 'Active',
    CreateBy: Name,
    CPerson: '',
    CatalogueProduct: [
      {
        CatalogProduct: '',
        CatalogCode: ''
      }
    ]
  });
  const [updateCatalogueid, setUpdateCatalogueid] = useState('');

  const fetchAndProcessCatalogueData = async () => {
    try {
      const response = await fetch(
        `${ipp}/api/catalogues?populate=*&filters[CatalogueCode][$eq]=${updateCatalogue}`
      );
      const json = await response.json();
      setUpdateCatalogueid(json?.data[0]?.id);
      setCata(json.data[0].attributes);
      const CatalogueProduct = json.data[0].attributes.CatalogueProduct;
      const ProductSizes = json.data[0].attributes.ProductSizes;
      data1234.map(item => {
        // Find the corresponding CatalogueProduct object using CatalogProduct as the key
        const matchedProduct = CatalogueProduct.find(
          prod => prod.CatalogProduct === String(item.id)
        );

        if (matchedProduct) {
          // Update the fields of data1234 item based on the matched CatalogueProduct
          item.attributes.CategoryName = matchedProduct.catcd;
          item.attributes.ProductTypeName = matchedProduct.prodtypecd;
          item.attributes.ProductId = matchedProduct.aliascd;
          item.attributes.ProductName = matchedProduct.productname;
          item.attributes.Description = matchedProduct.description;
          item.attributes.SizeUnit = matchedProduct.unit;
          item.attributes.Length = matchedProduct.len;
          item.attributes.Width = matchedProduct.wid;
          item.attributes.Height = matchedProduct.thick;
          item.attributes.FinishName = matchedProduct.finish;
          item.attributes.ColorName = matchedProduct.color;
          item.attributes.NetWeight = matchedProduct.netwgt;
          item.attributes.GrossWeight = matchedProduct.grswgt;
          item.attributes.SellingPrice = matchedProduct.saleprice;
          item.attributes.SellingPriceCurrency = matchedProduct.currency;
          item.attributes.Product_Remark = matchedProduct.remark;
          item.attributes.cbm = matchedProduct.Total_CBM;
          item.attributes.SizeRange = matchedProduct.SizeRange;
        }
        return item;
      });

      data1234.map(item => {
        const matchedSizes = ProductSizes.filter(size => {
          return size.CatalogueProduct == item.attributes.ProductId;
        });
        matchedSizes.forEach(item => {
          const color = colordata.find(colorItem => colorItem.value === item.ColorCode);
          if (color) {
            item.ColorName = color.label; // Add ColorName to the item
          }
          item.SizeUnit = item.Unit; // Add ColorName to the item
        });

        if (matchedSizes.length > 0) {
          item.attributes.SetSizes = matchedSizes;
        }
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const [colltectiondata, setCollectiondata] = useState([]);
  const [colltectionMeta, setCollectionMeta] = useState();
  useEffect(() => {
    fetchDatac();
    setTimeout(() => {
      fetchAndProcessCatalogueData();
    }, 2000);
  }, []);
  const fetchDatac = async () => {
    const response = await fetch(`${ipp}/api/collections`);
    const json = await response.json();
    setCollectiondata(json.data);
    setCollectionMeta(json.meta);
  };

  const [cataloguedata, setCataloguedata] = useState([]);
  const [catalogueMeta, setcatalogueMeta] = useState();
  useEffect(() => {
    fetchData0();
  }, []);
  const fetchData0 = async () => {
    const response = await fetch(`${ipp}/api/catalogues?populate=*`);
    const json = await response.json();
    setCataloguedata(json.data);
    setcatalogueMeta(json.meta);
  };

  const generateCatalogue = () => {
    const nextCode = catalogueMeta?.pagination?.total + 1;
    return `CATLG-${nextCode.toString().padStart(3, '0')}`;
  };

  const generateCollection = () => {
    const nextCode = colltectionMeta?.pagination?.total + 1;
    return `COl-${nextCode.toString().padStart(3, '0')}`;
  };

  const url2 = `${ipp}/api/catalogues`;
  const submit = async e => {
    console.log("object")
    e.preventDefault();
    const trimmedCatalogueName = cata.catalogueName.trim();
    const trimmedCPersonName = cata.CPerson.trim();
    if (trimmedCatalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      const { data: clcode } = await axios.get(`${globalIP}/api/catalogues?populate=*`);
      const nextCode = clcode.meta.pagination.total + 1;
      const formData = new FormData();
      if (edit === true) {
        const updatedCatalogue = {
          ...cata,
          catalogueName: trimmedCatalogueName,
          CPerson: trimmedCPersonName,
          ...selectedAttributes,
          CatalogueCode: `CATLG-${nextCode.toString().padStart(3, '0')}`,
          CatalogueProduct: Object.keys(editedData).map(rowId => ({
            CatalogProduct: rowId, // Assuming ProductId is the unique identifier
            CatalogCode: `CATLG-${nextCode.toString().padStart(3, '0')}`,
            catcd: editedData[rowId]?.CategoryName,
            prodtypecd: editedData[rowId]?.ProductTypeName,
            aliascd: editedData[rowId]?.ProductId,
            productname: editedData[rowId]?.ProductName,
            description: editedData[rowId]?.Description,
            unit: editedData[rowId]?.SizeUnit,
            len: editedData[rowId]?.Length,
            wid: editedData[rowId]?.Width,
            thick: editedData[rowId]?.Height,
            finish: editedData[rowId]?.FinishName,
            color: editedData[rowId]?.ColorName,
            netwgt: editedData[rowId]?.NetWeight,
            grswgt: editedData[rowId]?.GrossWeight,
            saleprice: editedData[rowId]?.SellingPrice,
            currency: editedData[rowId]?.SellingPriceCurrency,
            remark: editedData[rowId]?.Product_Remark,
            shape: 'N/A',
            cbm: editedData[rowId]?.Total_CBM,
            SizeRange: editedData[rowId]?.SizeRange
          })),
          ProductSizes: Object.entries(editedData)
            .map(([key, item]) => {
              if (item.SetStatus == 'Set') {
                return item.SetSizes.map(setSize => ({
                  CatalogueProduct: String(key), // Use ProductId as CatalogueProduct
                  CatalogueCode: `CATLG-${nextCode.toString().padStart(3, '0')}`, // Assuming nextCatalogueCode is defined somewhere in your code
                  Unit: String(setSize.SizeUnit),
                  Length: setSize.Length,
                  Width: setSize.Width,
                  Height: setSize.Height,
                  cbm: setSize.cbm,
                  Description: String(setSize.Description),
                  ColorCode: setSize.ColorCode || '', // Default to empty string if ColorCode is not available
                  FinishCode: setSize.FinishCode || '', // Default to empty string if ColorCode is not available
                  NetWt: setSize.NetWt,
                  MatName: setSize.MatName,
                  Rate: setSize.SetRate,
                  status: setSize.status
                }));
              } else {
                return [];
              }
            })
            .flat()
        };

        formData.append('data', JSON.stringify(updatedCatalogue));
        fetch(url2, {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
          })
          .catch(error => console.error(error));
        catalogueCodeCounter++;
        toaster.push(
          <Message showIcon type="success">
            Saved Successfully
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const updatedCatalogue = {
          ...cata,
          catalogueName: trimmedCatalogueName,
          CPerson: trimmedCPersonName,
          ...selectedAttributes,
          CatalogueCode: `CATLG-${nextCode.toString().padStart(3, '0')}`,
          CatalogueProduct: data1234.map(item => ({
            CatalogProduct: String(item.id),
            CatalogCode: `CATLG-${nextCode.toString().padStart(3, '0')}`,
            catcd: String(item.attributes.CategoryName),
            prodtypecd: String(item.attributes.ProductTypeName),
            aliascd: String(item.attributes.ProductId),
            productname: String(item.attributes.ProductName),
            description: String(item.attributes.Description),
            unit: String(item.attributes.SizeUnit),
            len: item.attributes.Length,
            wid: item.attributes.Width,
            thick: item.attributes.Height,
            finish: String(item.attributes.FinishName),
            color: String(item.attributes.ColorName),
            netwgt: item.attributes.NetWeight,
            grswgt: item.attributes.GrossWeight,
            saleprice: item.attributes.SellingPrice,
            currency: String(item.attributes.SellingPriceCurrency),
            remark: String(item.attributes.Product_Remark),
            shape: 'N/A',
            cbm: item.attributes.Total_CBM,
            SizeRange: String(item.attributes.SizeRange)
          })),
          ProductSizes: data1234
            .map(item => {
              if (item.attributes.SetStatus == 'Set') {
                return item.attributes.SetSizes.map(setSize => ({
                  CatalogueProduct: String(item.id),
                  CatalogueCode: `CATLG-${nextCode.toString().padStart(3, '0')}`,
                  Unit: String(setSize.SizeUnit),
                  Length: setSize.Length,
                  Width: setSize.Width,
                  Height: setSize.Height,
                  cbm: setSize.cbm,
                  Description: String(setSize.Description),
                  ColorCode: setSize.ColorCode || '',
                  FinishCode: setSize.FinishCode || '', // Default to empty string if ColorCode is not available
                  NetWt: setSize.NetWt,
                  MatName: setSize.MatName,
                  Rate: setSize.SetRate,
                  status: setSize.status
                }));
              } else {
                return [];
              }
            })
            .flat()
        };
        formData.append('data', JSON.stringify(updatedCatalogue));
        fetch(url2, {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
          })
          .catch(error => console.error(error));
        catalogueCodeCounter++;
        toaster.push(
          <Message showIcon type="success">
            Saved Successfully
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  //** final */
  const updateSubmit = async () => {
    try {
      const trimmedCatalogueName = cata.catalogueName.trim();
      const nextCatalogueCode = updateCatalogue;

      // Step 1: Fetch existing catalogue
      const existingResponse = await fetch(`${ipp}/api/catalogues/${updateCatalogueid}?populate=*`);
      const existingData = await existingResponse.json();

      if (!existingResponse.ok || !existingData?.data) {
        throw new Error("Failed to fetch existing catalogue");
      }

      const oldCatalogue = existingData.data.attributes;

      // Step 2: Start with existing data
      const updatedCatalogue = {
        ...oldCatalogue, // preserve all existing values
        CatalogueCode: nextCatalogueCode, // always keep code same
        CatalogueProduct: [],
        ProductSizes: [],
      };

      // Step 3: Conditionally update basic info (only if changed)
      if (trimmedCatalogueName && trimmedCatalogueName !== oldCatalogue.catalogueName)
        updatedCatalogue.catalogueName = trimmedCatalogueName;

      if (cata.BuyerCompany && cata.BuyerCompany !== oldCatalogue.BuyerCompany)
        updatedCatalogue.BuyerCompany = cata.BuyerCompany;

      if (cata.BuyerName && cata.BuyerName !== oldCatalogue.BuyerName)
        updatedCatalogue.BuyerName = cata.BuyerName;

      if (cata.CPerson && cata.CPerson !== oldCatalogue.CPerson)
        updatedCatalogue.CPerson = cata.CPerson;

      if (cata.BuyerEmail && cata.BuyerEmail !== oldCatalogue.BuyerEmail)
        updatedCatalogue.BuyerEmail = cata.BuyerEmail;

      // Step 4: Build updated product + size lists
      const productSource = edit ? editedData : data1234;
      const isEditMode = !!edit;

      updatedCatalogue.CatalogueProduct = (isEditMode
        ? Object.keys(productSource).map(rowId => ({
          CatalogProduct: rowId,
          CatalogCode: nextCatalogueCode,
          catcd: productSource[rowId]?.CategoryName,
          prodtypecd: productSource[rowId]?.ProductTypeName,
          aliascd: productSource[rowId]?.ProductId,
          productname: productSource[rowId]?.ProductName,
          description: productSource[rowId]?.Description,
          unit: productSource[rowId]?.SizeUnit,
          len: productSource[rowId]?.Length,
          wid: productSource[rowId]?.Width,
          thick: productSource[rowId]?.Height,
          finish: productSource[rowId]?.FinishName,
          color: productSource[rowId]?.ColorName,
          netwgt: productSource[rowId]?.NetWeight,
          grswgt: productSource[rowId]?.GrossWeight,
          saleprice: productSource[rowId]?.SellingPrice,
          currency: productSource[rowId]?.SellingPriceCurrency,
          remark: productSource[rowId]?.Product_Remark,
          shape: 'N/A',
          cbm: productSource[rowId]?.Total_CBM,
          SizeRange: productSource[rowId]?.SizeRange
        }))
        : productSource.map(item => ({
          CatalogProduct: String(item.id),
          CatalogCode: nextCatalogueCode,
          catcd: String(item.attributes.CategoryName),
          prodtypecd: String(item.attributes.ProductTypeName),
          aliascd: String(item.attributes.ProductId),
          productname: String(item.attributes.ProductName),
          description: String(item.attributes.Description),
          unit: String(item.attributes.SizeUnit),
          len: item.attributes.Length,
          wid: item.attributes.Width,
          thick: item.attributes.Height,
          finish: String(item.attributes.FinishName),
          color: String(item.attributes.ColorName),
          netwgt: item.attributes.NetWeight,
          grswgt: item.attributes.GrossWeight,
          saleprice: item.attributes.SellingPrice,
          currency: String(item.attributes.SellingPriceCurrency),
          remark: String(item.attributes.Product_Remark),
          shape: 'N/A',
          cbm: item.attributes.Total_CBM,
          SizeRange: String(item.attributes.SizeRange)
        }))
      );

      updatedCatalogue.ProductSizes = isEditMode
        ? Object.entries(productSource)
          .flatMap(([key, item]) =>
            item.SetStatus === 'Set'
              ? item.SetSizes.map(setSize => ({
                CatalogueProduct: String(key),
                CatalogueCode: nextCatalogueCode,
                Unit: String(setSize.SizeUnit),
                Length: setSize.Length,
                Width: setSize.Width,
                Height: setSize.Height,
                cbm: setSize.cbm,
                Description: String(setSize.Description),
                ColorCode: setSize.ColorCode || '',
                FinishCode: setSize.FinishCode || '',
                NetWt: setSize.NetWt,
                MatName: setSize.MatName,
                Rate: setSize.SetRate,
                status: setSize.status
              }))
              : []
          )
        : productSource
          .flatMap(item =>
            item.attributes.SetStatus === 'Set'
              ? item.attributes.SetSizes.map(setSize => ({
                CatalogueProduct: String(item.id),
                CatalogueCode: nextCatalogueCode,
                Unit: String(setSize.SizeUnit),
                Length: setSize.Length,
                Width: setSize.Width,
                Height: setSize.Height,
                cbm: setSize.cbm,
                Description: String(setSize.Description),
                ColorCode: setSize.ColorCode || '',
                FinishCode: setSize.FinishCode || '',
                NetWt: setSize.NetWt,
                MatName: setSize.MatName,
                Rate: setSize.SetRate,
                status: setSize.status
              }))
              : []
          );

      // Step 5: Delete old catalogue (clean slate)
      await fetch(`${ipp}/api/catalogues/${updateCatalogueid}`, { method: "DELETE" });

      // Step 6: Create new one with preserved + updated data
      const formData = new FormData();
      formData.append("data", JSON.stringify(updatedCatalogue));

      const createResponse = await fetch(`${ipp}/api/catalogues`, {
        method: "POST",
        body: formData
      });

      const created = await createResponse.json();

      if (createResponse.ok) {
        handleOpenmaster()
        // toaster.push(
        //   <Message showIcon type="success">
        //     Catalogue Updated Successfully
        //   </Message>,
        //   { placement: "topCenter" }
        // );
        // handleClose5();
        // Navigate(`/${ugr}/manageCatalogue`);
      } else {
        console.error("Create failed", created);
        toaster.push(
          <Message showIcon type="error">
            Failed to update catalogue
          </Message>,
          { placement: "topCenter" }
        );
      }
    } catch (err) {
      console.error("Error updating:", err);
      toaster.push(
        <Message showIcon type="error">
          Server error occurred
        </Message>,
        { placement: "topCenter" }
      );
    }
  };

  const submit2 = async e => {
    e.preventDefault();
    if (cata.catalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      const { data: clcode } = await axios.get(`${globalIP}/api/catalogues?populate=*`);
      const nextCode = clcode.meta.pagination.total + 1;
      const formData = new FormData();
      const updatedCatalogue = {
        ...cata,
        CatalogueCode: `CATLG-${nextCode.toString().padStart(3, '0')}`,
        Status: 'Draft',
        ...selectedAttributes,
        CatalogueProduct: data1234.map(item => ({
          CatalogProduct: String(item.id),
          CatalogCode: `CATLG-${nextCode.toString().padStart(3, '0')}`,
          catcd: String(item.attributes.CategoryName),
          prodtypecd: String(item.attributes.ProductTypeName),
          aliascd: String(item.attributes.ProductId),
          productname: String(item.attributes.ProductName),
          description: String(item.attributes.Description),
          unit: String(item.attributes.SizeUnit),
          len: item.attributes.Length,
          wid: item.attributes.Width,
          thick: item.attributes.Height,
          finish: String(item.attributes.FinishName),
          color: String(item.attributes.ColorName),
          netwgt: item.attributes.NetWeight,
          grswgt: item.attributes.GrossWeight,
          saleprice: item.attributes.SellingPrice,
          currency: String(item.attributes.SellingPriceCurrency),
          remark: String(item.attributes.Product_Remark),
          shape: 'N/A',
          cbm: item.attributes.Total_CBM,
          SizeRange: String(item.attributes.SizeRange)
        }))
      };
      formData.append('data', JSON.stringify(updatedCatalogue));
      fetch(url2, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          handleClose2();
          handleOpen4();
        })
        .catch(error => console.error(error));
      catalogueCodeCounter++;
      // toaster.push(<Message showIcon type='success' >
      //   Saved Successfully
      // </Message>, { placement: 'topCenter' });
    }
  };

  const url3 = `${ipp}/api/collections`;
  const submitCollection = async (e) => {
    e?.preventDefault();

    if (!coll.CollectionName.trim()) {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Collection Name
        </Message>,
        { placement: "topEnd" }
      );
      return null;
    }

    try {
      const { data: clcode } = await axios.get(`${globalIP}/api/collections?populate=*`);

      const collections = clcode?.data || [];
      const latestCode = collections[0]?.attributes?.CollectionCode || "COL-000";

      const lastNum = parseInt(latestCode.replace(/\D/g, ""), 10) || 0;
      let nextNum = lastNum + 1;
      // ✅ Add a fallback to make it always unique, even if same number is used
      // Combine with timestamp (short unique suffix)
      const uniqueSuffix = Date.now().toString().slice(-4);
      const newCollectionCode = `COL-${nextNum.toString().padStart(3, "0")}-${uniqueSuffix}`;
      const selectedProductCodes = data1234.map((item) => item.id);
      const updatedCatalogue = {
        ...coll,
        CollectionCode: newCollectionCode,
        CollectionProduct: selectedProductCodes.map((productid) => ({
          ColProduct: String(productid),
          CollectionCode: newCollectionCode,
        })),
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(updatedCatalogue));

      const createResponse = await fetch(url3, { method: "POST", body: formData });
      const createdData = await createResponse.json();
      const newId = createdData?.data?.id;

      if (newId) {
        const fullRes = await fetch(`${globalIP}/api/collections/${newId}?populate=*`);
        const populated = await fullRes.json();
        const fullData = populated?.data;

        toaster.push(
          <Message showIcon type="success">
            Saved Successfully
          </Message>,
          { placement: "topCenter" }
        );

        return fullData;
      }

      return null;
    } catch (error) {
      console.error("❌ Error creating collection:", error);
      toaster.push(
        <Message showIcon type="error">
          Something went wrong. Please try again.
        </Message>,
        { placement: "topEnd" }
      );
      return null;
    }
  }
  // const [spt1Name, setSTP1Name] = useState('')
  const handleInputChange = (inputName, event, index) => {
    let value;
    if (event && event.target) {
      // If event is not null and has a target property
      value = event.target.value;
    } else {
      // Handle cases where event is null or doesn't have a target property
      value = event;
    }
    if (inputName == 'BuyerCompany') {
      setSelectedCompany(value);
    }
    if (inputName == 'BuyerName') {
      setSelectedBuyer(value);
    }

    setCata({ ...cata, [inputName]: value });
    setCompany({ ...company, [inputName]: value });
    setBuyer({ ...buyer, [inputName]: value });
  };
  const handleInputChangec = (inputName, event, index) => {
    let value;
    if (event && event.target) {
      // If event is not null and has a target property
      value = event.target.value;
    } else {
      // Handle cases where event is null or doesn't have a target property
      value = event;
    }
    if (inputName == 'BuyerCompany') {
      setSelectedCompany(value);
    }
    if (inputName == 'BuyerName') {
      setSelectedBuyer(value);
    }
    setColl({ ...coll, [inputName]: value });
  };

  const [openmaster, setOpenmaster] = useState(false);
  const handleOpenmaster = () => setOpenmaster(true);
  const handleClosemasterNo = () => {
    submit(event);
    setOpenmaster(false);
    uddateProduct(data1234);
  };
  const [loadingMaster, setLoadingMaster] = useState(false)
  const handleClosemasterYes = async (event) => {
    setLoadingMaster(true)
    try {
      await saveDataForTempToAPI();
      await submit(event);
      await uddateProduct(data1234);
      setOpenmaster(false);
    } catch (error) {
      console.error('Error in closing master:', error);
    } finally {
      setLoadingMaster(true)
    }
  };

  const Navigate = useNavigate();
  const submitCatalogue = () => {
    if (cata.catalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else if (edit === false) {
      submit(event);
      setOpenmaster(false);
      uddateProduct(data1234);
    } else if (user.CATaccessPPT === false || user.Category === 'Admin') {
      handleClosemasterNo();
    } else {
      handleOpenmaster();
    }
  };
  const datattt2 = () => {
    if (cata.catalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      submit2(event);
    }
  };

  const createCollection = async (event) => {
    if (!coll.CollectionName.trim()) {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Collection Name
        </Message>,
        { placement: 'topEnd' }
      );
      return;
    }

    const latestCollection = await submitCollection(event);

    if (latestCollection?.attributes?.CollectionCode) {
      await uddateProductc(data1234, latestCollection);
    } else {
      toaster.push(
        <Message showIcon type="error">
          Failed to create collection
        </Message>,
        { placement: "topEnd" }
      );
    }
  };

  const [companydataa, setCompanydataa] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  useEffect(() => {
    fetchData6();
  }, []);

  const fetchData6 = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/buyer-companies?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/buyer-companies?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.companynm,
          value: item.attributes.companynm
        }));
        allData.push(...processedData);
      }
      setCompanydataa(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [buyeerdata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  const [isNewBuyerAdd, setIsNewBuyerAdd] = useState(false);
  const buyeerdata1 = [];
  useEffect(() => {
    fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu);
  }, [isNewBuyerAdd]);
  const filteredBuyerData = selectedCompany
    ? buyeerdata.filter(item => item.company === selectedCompany)
    : buyeerdata;

  const [temp, setTemp] = React.useState([]);
  useEffect(() => {
    fetchDatatemp();
  }, []);

  const fetchDatatemp = async () => {
    try {
      const response = await fetch(`${ip}/api/temp-libs`);
      const json = await response.json();
      setTemp(json.data);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [selectedBuyer, setSelectedBuyer] = useState(null); // Step 1

  // Step 2: Check if there's a matching Temp_Buyer in the temp data
  const findMatchingTempBuyer = () => {
    const tempBuyer = temp.find(item => item.attributes.Temp_Buyer === selectedBuyer);
    return tempBuyer ? tempBuyer.attributes.Temp_Name : null;
  };
  const defaultTempBuyer = temp.find(item => item.attributes.Temp_Buyer === 'Default');
  const defaultTempName = defaultTempBuyer ? defaultTempBuyer.attributes.Temp_Name : null;

  // Step 3: Render the SPT1 div conditionally
  const spt1Name = findMatchingTempBuyer();

  const [showModal, setShowModal] = useState(false);

  const [modalSelectedItems, setModalSelectedItems] = useState([]);
  const handleOpenModal = () => {
    setShowModal(true);
    setModalSelectedItems(data1234.map(item => item.id)); // Initialize with currently selected products
  };

  const toggleEdit = () => {
    if (edit) {
      cancelEdit(); // If currently in edit mode, cancel editing
    } else {
      data1234.forEach(item => handleEditRow(item.id)); // Otherwise, start editing
    }
  };
  const handleEditRow = id => {
    setEditedRowIds(prevRowIds => [...prevRowIds, id]);
    setEditedData(prevData => ({
      ...prevData,
      [id]: { ...data1234.find(item => item.id === id).attributes }
    }));
    setShowIcon(!showIcon);
    setEdit(true);
  };
  useEffect(() => {
    if (edit) {
      // Add newly added products to edit mode automatically
      const newIds = data1234.map(item => item.id).filter(id => !editedRowIds.includes(id));
      newIds.forEach(id => handleEditRow(id));
    }
  }, [data1234]);
  const cancelEdit = () => {
    setEditedRowIds([]);
    setEditedData({});
    setEdit(false);
  };
  const handleSaveRow = async () => {
    try {
      const updatedRows = Object.keys(editedData).map(async rowId => {
        const rowData = data1234.find(row => row.id === Number(rowId));
        const updatedRowData = {
          ...rowData,
          attributes: {
            ...editedData[rowId], // Spread the properties from editedData[rowId]
            Packaging: rowData.attributes.Packaging // Override or add Packaging property
          }
        };

        delete updatedRowData.attributes.CoverImage;
        delete updatedRowData.attributes.MultipleImage;

        const response = await fetch(`${ipp}/api/products/${rowId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ data: updatedRowData.attributes })
        });

        if (!response.ok) {
          // Handle error if needed
          console.error(`Failed to save data for row with ID ${rowId}`);
        }

        return rowId;
      });

      // Wait for all requests to complete
      await Promise.all(updatedRows);

      // If all requests are successful, update the data
      fetchData();
      setEditedRowIds([]);
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChange2 = (rowId, fieldName, value) => {
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = {
          ProductName: '',
          Description: '',
          NetWeight: 0,
          GrossWeight: 0,
          Product_Remark: ''
        };
      }
      updatedData[rowId][fieldName] = value;
      // Check if the currency changed, then calculate SellingPrice
      if (fieldName === 'SellingPriceCurrency') {
        const productCost = updatedData[rowId]?.ProductCost;
        const selectedCurrency = value; // The selected currency

        // Find the exchange rate for the selected currency
        const currency = currencydata.find(item => item.label === selectedCurrency);
        if (currency && productCost) {
          const exchangeRate = currency.exchangerate;

          // Calculate the selling price based on the exchange rate
          const calculatedSellingPrice = productCost / exchangeRate;

          // Update salepri with the calculated selling price
          updatedData[rowId].SellingPrice = calculatedSellingPrice.toFixed(2);
        }
      }
      return updatedData;
    });
  };

  const [productTypeDataPerRow, setProductTypeDataPerRow] = useState({});
  const handleInputChange3 = (rowId, fieldName, codeFieldName, value, data) => {
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = {
          ProductName: '',
          Description: '',
          NetWeight: 0,
          GrossWeight: 0,
          Product_Remark: ''
        };
      }
      const selectedData = data.find(item => item.label === value);
      updatedData[rowId][fieldName] = value;
      updatedData[rowId][codeFieldName] = selectedData ? selectedData.value : ''; // Set Code based on selected Name
      return updatedData;
    });
  };

  const [data5, setData5] = useState({
    Total_CBM: 0,
    Total_CFT: 0,
    TwentyFT: '',
    FortyFT: '',
    FortyHQ: '',
    Packaging: [
      {
        CartonType: 'master',
        ProductCode: '',
        Carton_Unit: 'inch',
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 0,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0
      }
    ]
  });

  const handleInputChange1 = (inputName, event, index) => {
    let value;
    if (event && event.target) {
      // If event is not null and has a target property
      value = event.target.value;
    } else {
      // Handle cases where event is null or doesn't have a target property
      value = event;
    }
    if (inputName.startsWith('CartonType')) {
      // Handling CartonType input change

      var unitlen = 0;
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].CartonType = value;
        unitlen = updatedPackaging.length;
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });

      var productcbm = 0;
      // Handling Carton_Width input change
      var len = data5.Packaging[index].Carton_Length;
      var wid = data5.Packaging[index].Carton_Width;
      var thic = data5.Packaging[index].Carton_Thick;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS;
      if (unit === 'cm') {
        productcbm = (len * wid * thic) / 1000000;
      } else {
        productcbm = (len * wid * thic) / 61023;
      }
      var prs = productcbm / pcc;
      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;
        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === 'cm') {
          productcbm1 = (len * wid * thic) / 1000000 / pcs1;
        } else {
          productcbm1 = (len * wid * thic) / 61023 / pcs1;
        }
        if (cartontype === 'master') {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }
      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[index].Carton_CBMperpc = Number(productcbm.toFixed(4));
        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      } else {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      }
    } else if (inputName.startsWith('Carton_Unit')) {
      // Handling Carton_Unit input change

      var unitlen = 0;
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Unit = value;
        unitlen = updatedPackaging.length;

        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });

      var productcbm = 0;
      // Handling Carton_Width input change
      var len = data5.Packaging[index].Carton_Length;
      var wid = data5.Packaging[index].Carton_Width;
      var thic = data5.Packaging[index].Carton_Thick;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS;
      if (unit === 'cm') {
        productcbm = (len * wid * thic) / 1000000;
      } else {
        productcbm = (len * wid * thic) / 61023;
      }
      var prs = productcbm / pcc;
      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === 'cm') {
          productcbm1 = (len * wid * thic) / 1000000 / pcs1;
        } else {
          productcbm1 = (len * wid * thic) / 61023 / pcs1;
        }
        if (cartontype === 'master') {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }
      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[index].Carton_CBMperpc = Number(productcbm.toFixed(4));
        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      } else {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      }
    } else if (inputName.startsWith('Carton_Length')) {
      var unitlen = 0;
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Length = value;
        unitlen = updatedPackaging.length;
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });
      var productcbm = 0;
      // Handling MatNetWeight input change
      const materialIndex = inputName.split('_')[2];
      var len1 = value;
      var wid = data5.Packaging[materialIndex].Carton_Width;
      var thic = data5.Packaging[materialIndex].Carton_Thick;
      var unit = data5.Packaging[materialIndex].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS;
      if (unit === 'cm') {
        productcbm = (len1 * wid * thic) / 1000000;
      } else {
        productcbm = (len1 * wid * thic) / 61023;
      }
      var prs = productcbm / pcc;
      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === 'cm') {
          productcbm1 = (len * wid * thic) / 1000000 / pcs1;
        } else {
          productcbm1 = (len * wid * thic) / 61023 / pcs1;
        }
        if (cartontype === 'master') {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }
      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[materialIndex].Carton_Length = parseFloat(value);

        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });

      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[materialIndex].Carton_CBMperpc = Number(productcbm.toFixed(4));

        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      } else {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      }
    } else if (inputName.startsWith('Carton_Width')) {
      var unitlen = 0;
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Width = value;
        unitlen = updatedPackaging.length;

        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });
      var productcbm = 0;
      // Handling Carton_Width input change
      var len = data5.Packaging[index].Carton_Length;
      var wid1 = value;
      var thic = data5.Packaging[index].Carton_Thick;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS;
      if (unit === 'cm') {
        productcbm = (len * wid1 * thic) / 1000000;
      } else {
        productcbm = (len * wid1 * thic) / 61023;
      }

      var prs = productcbm / pcc;
      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === 'cm') {
          productcbm1 = (len * wid * thic) / 1000000 / pcs1;
        } else {
          productcbm1 = (len * wid * thic) / 61023 / pcs1;
        }
        if (cartontype === 'master') {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }

      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Width = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });

      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[index].Carton_CBMperpc = Number(productcbm.toFixed(4));
        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      } else {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      }
    } else if (inputName.startsWith('Carton_Thick')) {
      // Handling Carton_Thick input change
      var unitlen = 0;
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Thick = value;
        unitlen = updatedPackaging.length;
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });

      var productcbm = 0;
      var len = data5.Packaging[index].Carton_Length;
      var wid = data5.Packaging[index].Carton_Width;
      var thic1 = value;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS;
      if (unit === 'cm') {
        productcbm = (len * wid * thic1) / 1000000;
      } else {
        productcbm = (len * wid * thic1) / 61023;
      }

      var prs = productcbm / pcc;

      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === 'cm') {
          productcbm1 = (len * wid * thic) / 1000000 / pcs1;
        } else {
          productcbm1 = (len * wid * thic) / 61023 / pcs1;
        }
        if (cartontype === 'master') {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }

      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_Thick = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });

      setData5(prevData => {
        const updatedMaterials = [...prevData.Packaging];
        updatedMaterials[index].Carton_CBMperpc = Number(productcbm.toFixed(4));
        return {
          ...prevData,
          Packaging: updatedMaterials
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      } else {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      }
    } else if (inputName.startsWith('Carton_PCS')) {
      // Handling Carton_PCS input change
      var unitlen = 0;
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_PCS = value;
        unitlen = updatedPackaging.length;

        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });

      var productcbm = 0;
      var len = data5.Packaging[index].Carton_Length;
      var wid = data5.Packaging[index].Carton_Width;
      var thic = data5.Packaging[index].Carton_Thick;
      var unit = data5.Packaging[index].Carton_Unit;
      var pcc = data5.Packaging[index].Carton_PCS;
      if (unit === 'cm') {
        productcbm = (len * wid * thic) / 1000000;
      } else {
        productcbm = (len * wid * thic) / 61023;
      }

      var prs = productcbm / pcc;

      var totalcbm = 0;
      var productcbm1 = 0;
      for (var x = 0; x < unitlen; x++) {
        // Handling Carton_Width input change
        var len = data5.Packaging[x].Carton_Length;

        var wid = data5.Packaging[x].Carton_Width;
        var thic = data5.Packaging[x].Carton_Thick;
        var unit = data5.Packaging[x].Carton_Unit;
        var cartontype = data5.Packaging[x].CartonType;
        var pcs1 = data5.Packaging[x].Carton_PCS;

        if (unit === 'cm') {
          productcbm1 = (len * wid * thic) / 1000000 / pcs1;
        } else {
          productcbm1 = (len * wid * thic) / 61023 / pcs1;
        }
        if (cartontype === 'master') {
          totalcbm = totalcbm + productcbm1;
        }
        setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
        var bb = totalcbm ? totalcbm * 35.3147 : 0;
        setTotalCFT(bb.toFixed(4));
        setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
        setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
        setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
      }

      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_PCS = parseInt(value, 10);
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });
      if (data5.Packaging[index].Carton_PCS == 0) {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(productcbm.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      } else {
        setData5(prevData => {
          const updatedPackaging = [...prevData.Packaging];
          updatedPackaging[index].Carton_CBM = Number(prs.toFixed(4));
          return {
            ...prevData,
            Packaging: updatedPackaging
          };
        });
      }
    } else if (inputName.startsWith('Carton_CBM')) {
      // Handling Carton_CBM input change
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_CBM = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });
    } else if (inputName.startsWith('Perpc')) {
      // Handling Carton_CBMperpc input change
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_CBMperpc = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });
    } else if (inputName.startsWith('Carton_GrsWt')) {
      // Handling Carton_GrsWt input change
      setData5(prevData => {
        const updatedPackaging = [...prevData.Packaging];
        updatedPackaging[index].Carton_GrsWt = parseFloat(value);
        return {
          ...prevData,
          Packaging: updatedPackaging
        };
      });
    }
  };

  const deletePackege = index => {
    setData5(prevData => {
      const updatedMaterials = [...prevData.Packaging];
      updatedMaterials.splice(index, 1);
      return {
        ...prevData,
        Packaging: updatedMaterials
      };
    });
  };
  const addPackaging = () => {
    setData5(prevData => {
      const newPackaging = {
        CartonType: '',
        ProductCode: '0',
        Carton_Unit: '',
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 0,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0
      };

      return {
        ...prevData,
        Packaging: [...prevData.Packaging, newPackaging]
      };
    });
  };

  const [productdata, setProductData] = useState([]);
  useEffect(() => {
    if (cbmeditdata) {
      fetchDatatPdata();
    }
  }, [cbmeditdata]);
  useEffect(() => {
    if (!productdata || productdata.length === 0) {
      setTotalCbm(0);
      setTotalCFT(0);
      setFeet20(0);
      setFeet40(0);
      setFeet20hc(0);
    }
  }, [productdata]);

  const fetchDatatPdata = async () => {
    try {
      const response = await fetch(`${ip}/api/products?populate=*&filters[id][$eq]=${cbmeditdata}`);
      const json = await response.json();
      setProductData(json.data);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  useEffect(() => {
    if (productdata) {
      fetchDatatset();
    }
  }, [productdata]);

  const fetchDatatset = async () => {
    if (productdata && productdata.length > 0) {
      const firstProduct = productdata[0].attributes;

      setTotalCbm(firstProduct.Total_CBM);
      setTotalCFT(firstProduct.Total_CFT);
      setFeet20(firstProduct.TwentyFT);
      setFeet40(firstProduct.FortyFT);
      setFeet20hc(firstProduct.FortyHQ);

      // Set Packaging data
      setData5(prevData => ({
        ...prevData,
        Packaging: firstProduct.Packaging || [] // Assuming productdata has a property Packaging
      }));
    }
  };
  const submitpack = e => {
    e.preventDefault();
    const formData = new FormData();
    // Create an updatedCategory object with the modified data
    data5.Packaging.forEach((pack, index) => {
      formData.append(
        `Packaging[${index + 1}][ProductCode]`,
        productdata[0].attributes.ProductCode
      );
      formData.append(`Packaging[${index}][CartonType]`, pack.CartonType);
      formData.append(`Packaging[${index}][Carton_Unit]`, pack.Carton_Unit);
      formData.append(`Packaging[${index}][Carton_Length]`, String(pack.Carton_Length));
      formData.append(`Packaging[${index}][Carton_Width]`, String(pack.Carton_Width));
      formData.append(`Packaging[${index}][Carton_Thick]`, String(pack.Carton_Thick));
      formData.append(`Packaging[${index}][Carton_CBM]`, String(pack.Carton_CBM));
      formData.append(`Packaging[${index}][Carton_PCS]`, String(pack.Carton_PCS));
      formData.append(`Packaging[${index}][Carton_CBMperpc]`, String(pack.Carton_CBMperpc));
      formData.append(`Packaging[${index}][Carton_GrsWt]`, String(pack.Carton_GrsWt));
    });
    formData.append(
      'data',
      JSON.stringify({
        ...data5,
        Total_CBM: totalcbm1,
        Total_CFT: totalcft,
        TwentyFT: String(feet20),
        FortyFT: String(feet40),
        FortyHQ: String(feet20hc)
      })
    );

    // Send a PUT request to the API
    fetch(`${ip}/api/products/${cbmeditdata}`, {
      method: 'PUT', // Use PUT for updating
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        handleClosecbm();
        fetchData();
        toaster.push(
          <Message showIcon type="success">
            CBM Changes Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
      })
      .catch(error => {
        console.error(error);
      });
  };
  // useEffect(() => {
  //   if (data1234) {
  //     data1234.forEach(item => handleEditRow(item.id));
  //   }
  // }, [data1234]);

  const [datafortemp, setDataforTemp] = useState([]);
  useEffect(() => {
    if (selectedItemsArray) {
      fetchdatafortemp();
    }
  }, []);
  const fetchdatafortemp = async () => {
    const productIdsQueryParam = selectedItemsArray.map(id => `filters[id][$in][]=${id}`).join('&');
    // Construct the API URL by appending the query parameters
    const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*`;
    const response = await fetch(apiUrl);
    const json = await response.json();
    setDataforTemp(json.data);
  };

  const saveDataForTempToAPI = async () => {
    try {
      // Prepare data to be saved to the API
      for (const selectedProduct of datafortemp) {
        const formData = new FormData();
        formData.append(
          'data',
          JSON.stringify({
            P_Id: String(selectedProduct.id),
            ProductCode: selectedProduct.attributes.ProductCode,
            AliasCode: selectedProduct.attributes.ProductId,
            CatetegoryCode: selectedProduct.attributes.CategoryCode,
            ProductTypeCode: selectedProduct.attributes.ProductTypeCode,
            Unit: selectedProduct.attributes.SizeUnit,
            len: selectedProduct.attributes.Length,
            wid: selectedProduct.attributes.Width,
            height: selectedProduct.attributes.Height,
            description: selectedProduct.attributes.Description,
            productname: selectedProduct.attributes.ProductName,
            finish: selectedProduct.attributes.FinishName,
            color: selectedProduct.attributes.ColorName,
            currency: selectedProduct.attributes.SellingPriceCurrency,
            price: selectedProduct.attributes.ProductCost,
            netwgt: selectedProduct.attributes.NetWeight,
            grosswgt: selectedProduct.attributes.GrossWeight,
            remark: selectedProduct.attributes.Product_Remark
            //    // New fields
            //   Total_CBM: selectedProduct.attributes.Total_CBM,
            //   Total_CFT: selectedProduct.attributes.Total_CFT,
            //   TwentyFT: selectedProduct.attributes.TwentyFT,
            //   FortyFT: selectedProduct.attributes.FortyFT,
            //   FortyHQ: selectedProduct.attributes.FortyHQ,

            // // Packaging data
            // Packaging: selectedProduct.attributes.Packaging.map(pack => ({
            //   id: String(pack.id),
            //   CartonType: pack.CartonType,
            //   ProductCode: pack.ProductCode,
            //   Carton_Unit: pack.Carton_Unit,
            //   Carton_Length: pack.Carton_Length,
            //   Carton_Width: pack.Carton_Width,
            //   Carton_Thick: pack.Carton_Thick,
            //   Carton_CBM: pack.Carton_CBM,
            //   Carton_PCS: pack.Carton_PCS,
            //   Carton_CBMperpc: pack.Carton_CBMperpc,
            //   Carton_GrsWt: pack.Carton_GrsWt,
            // }))
          })
        );

        // Send a POST request using Fetch API
        const response = await fetch(`${ip}/api/temp-products`, {
          method: 'POST',
          body: formData
        });

        // Check if the response is successful
        if (response.ok) {
        } else {
          // Handle errors
          console.error('Failed to save data:', response.statusText);
        }
      }
    } catch (error) {
      console.error('Error saving data:', error);
    }
    handleSaveRow();
  };
  const [openMenu, setOpenMenu] = useState(false);
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 220; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);


  //**add buyer company and buyer name directly here */
  const [openCompModal, setOpenCompModal] = React.useState(false);
  const [size1, setSize1] = React.useState();
  const handleOpenCompModal = value => {
    setSize1(value);
    setOpenCompModal(true);
  };
  const handleCloseCompModal = () => setOpenCompModal(false);


  const [company, setCompany] = useState({
    companynm: '',
    dis: 'Continue'
  });

  // Fetch Data from API Start
  const [companydata, setCompanydata] = useState([]);
  const [editedRowIdscompany, setEditedRowIdscompany] = useState<string[]>([]);
  const [editedDatacompany, setEditedDatacompany] = useState<
    Record<string, Partial<RowDataForCompany['attributes']>>
  >({});
  useEffect(() => {
    fetchBuyerCompData();
  }, []);
  const fetchBuyerCompData = async () => {
    const response = await fetch(`${ip}/api/buyer-companies?populate=*&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/buyer-companies?populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setCompanydata(allData);
  };
  const handleEditRowcompany = rowData => {
    setEditedRowIdscompany(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDatacompany(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
  };
  const url = `${ip}/api/buyer-companies`;
  const validNameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]*$/;
  const submitCompany = e => {
    const trimmedCompanynm = company.companynm.trim();
    const existingBuyer = companydata.find(
      item => item.attributes.companynm.toLowerCase() === trimmedCompanynm.toLowerCase()
    );

    if (trimmedCompanynm === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Buyer Company Name.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    // else if (!validNameRegex.test(trimmedCompanynm)) {
    //   toaster.push(
    //     <Message showIcon type="error">
    //       Invalid Buyer Company Name. Only alphanumeric characters and spaces are allowed.
    //     </Message>,
    //     { placement: 'topCenter' }
    //   );
    // } 
    else if (existingBuyer) {
      toaster.push(
        <Message showIcon type="warning">
          {trimmedCompanynm} already exist.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      e.preventDefault();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...company, companynm: trimmedCompanynm }));

      fetch(url, {
        method: 'POST',
        body: formData
      })
        .then(response => fetchData())
        .then(data => {
          const newCompany = {
            label: trimmedCompanynm,
            value: trimmedCompanynm
          };

          setCompanydataa(prev => [...prev, newCompany]);

          // 2️⃣ auto-select new company
          setSelectedCompany(trimmedCompanynm);
          handleInputChange('BuyerCompany', trimmedCompanynm, 0);
          handleCloseCompModal()
          fetchData6()
          fetchBuyerCompData()

          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        })
        .catch(error => console.error(error));

      setCompany({
        companynm: '',
        dis: 'Continue'
      });

      toaster.push(
        <Message showIcon type="success">
          Data Save Successfully.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  // Delete Data from API End
  const handleSaveRowcompany = async (rowId: string) => {
    try {
      const editedcom = editedDatacompany[rowId]?.companynm;
      const trimmedCompanynm = editedcom.trim();
      const rowData = companydata.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const validNameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]*$/;
      if (!validNameRegex.test(trimmedCompanynm) || trimmedCompanynm.startsWith(' ')) {
        toaster.push(
          <Message showIcon type="error">
            Invalid Buyer Company Name. Only alphanumeric characters are allowed, and it cannot
            start with a space.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const existingBuyer = companydata.find(
        item =>
          item.attributes.companynm.toLowerCase() === trimmedCompanynm.toLowerCase() &&
          item.id !== rowId
      );

      if (existingBuyer) {
        toaster.push(
          <Message showIcon type="warning">
            {trimmedCompanynm} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const updatedRowData = {
          ...rowData,
          attributes: {
            ...rowData.attributes,
            ...editedDatacompany[rowId],
            companynm: trimmedCompanynm
          }
        };
        const response = await fetch(`${ip}/api/buyer-companies/${rowData.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ data: updatedRowData.attributes })
        });

        if (response.ok) {
          fetchData();
          setEditedRowIdscompany(prevRowIds => prevRowIds.filter(id => id !== rowId));
        } else {
          console.error('Failed to save data');
        }
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangecompany = (rowId, fieldName, value) => {
    setEditedDatacompany(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...companydata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };

  //**add new buyer directly here */
  const [openBuyerModal, setOpenBuyerModal] = React.useState(false);
  const [buyerModalsize, setBuyerModalSize] = React.useState();
  const handleOpenBuyerModal = value => {
    setBuyerModalSize(value);
    setOpenBuyerModal(true);
  };
  const handleCloseBuyerModal = () => {
    setOpenBuyerModal(false);
  };
  const [buyer, setBuyer] = useState({
    buyercode: '',
    companynm: '',
    buyernm: '',
    country: '',
    email: '',
    address: '',
    contactno: '',
    merchantnm: '',
    dis: 'Continue'
  });
  const [countrydata, setCountrydata] = useState([]);
  useEffect(() => {
    fetchDatacoutry();
  }, []);
  const fetchDatacoutry = async () => {
    try {
      const response = await fetch(
        `${ip}/api/countries?&pagination[page]=1`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/countries?&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.countrynm,
          value: item.attributes.countrynm
        }));
        allData.push(...processedData);
      }
      setCountrydata(allData);
    } catch (error) {
      console.error('Error fetching countries data:', error);
    }
  };

  const [merchant, setMarchant] = useState([]);

  useEffect(() => {
    fetchDatamar();
  }, []);
  const fetchDatamar = async () => {
    try {
      const response = await fetch(`${ip}/api/user-details`);
      const json = await response.json();
      const allUsers = json ? json.data : []
      const isMerchant_isActive = Array.isArray(allUsers) ?
        allUsers.filter((item) => (!item.attributes.isUserDiscontinue || item.attributes.isUserDiscontinue == null) && item.attributes.Designation == "Merchant")
        : []
      const processedData = isMerchant_isActive.map(item => ({
        label: item.attributes.Full_Name,
        value: item.attributes.UserCode
      }));
      setMarchant(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const fileInputRef = useRef(null);
  const [imageFile, setImageFile] = useState(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = event => {
    const file = event.target.files[0];

    if (file) {
      // Validate the file type
      const validTypes = ['image/jpeg', 'image/jpg'];
      if (!validTypes.includes(file.type)) {
        alert('Please upload a file in JPG or JPEG format.');
        return;
      }

      // Create a blob URL
      const blobFile = URL.createObjectURL(file);
      setImageFile(blobFile);

      // Call the handleImageUpload function
      handleImageUpload([{ file }]);
    }
  };
  const handleImageUpload = async fileList => {
    setBuyer({
      ...buyer,
      BuyerImage: fileList[0].file
    });
  };
  // Fetch Data from API Start
  const [buyerdata, setBuyerdata] = useState([]);
  const [buyMeta, setBuyMeta] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [progressBuyer, setProgressBuyer] = useState(0);
  useEffect(() => {
    fetchBuyerData();
  }, [selectedBuyer]);
  const fetchBuyerData = async () => {
    setProgressBuyer(30);
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let disFilter = '';
    if (selectedBuyer.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyer}`;
    }
    if (selectedBuyer == 'All') {
      disFilter = '';
    }
    try {
      const response = await fetch(
        `${ip}/api/buyer-details?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/buyer-details?populate=*&pagination[page]=${page}&sort[0]=id:desc${disFilter}`
        );

        const pageJson = await pageResponse.json();
        allData.push(...pageJson.data);
      }
      const responseformeta = await fetch(
        `${ip}/api/buyer-details?populate=*
          `
        // &publicationState=preview
      );
      const jsonmeta = await responseformeta.json();
      setProgressBuyer(60);
      setBuyMeta(jsonmeta.meta);
      setBuyerdata(allData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
      setProgressBuyer(100);
    }
  };
  const generateNextCategoryCode = () => {
    const nextCode = buyMeta?.pagination?.total + 1;
    return `BUYER-${nextCode.toString().padStart(3, '0')}`;
  };
  const buyerUrl = `${ip}/api/buyer-details`;
  const submitBuyer = async (e) => {
    const validNameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]*$/;

    if (buyer.companynm === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Buyer Company Name.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    else if (!validNameRegex.test(buyer.buyernm)) {
      toaster.push(
        <Message showIcon type="error">
          Invalid Buyer Name. Only alphanumeric characters and spaces are allowed.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (buyer.buyernm === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Buyer Name.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (buyer.country === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Country.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (buyer.email === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Buyer Email.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    // else if (buyer.contactno === '') {
    //   toaster.push(
    //     <Message showIcon type="error">
    //       Please Enter Contact number.
    //     </Message>,
    //     { placement: 'topCenter' }
    //   );
    // } 
    else if (!(buyer.contactno.trim().length <= 12)) {
      toaster.push(
        <Message showIcon type="error">
          Please check Contact no.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else {
      try {

        const { data: userData } = await axios.get(
          `${ip}/api/buyer-details?populate=*&filters[buyernm][$eqi]=${buyer.buyernm.trim()}`
        );

        // Check if the username exists
        const usernameExists = userData.data.some(
          user =>
            user.attributes.buyernm.toLowerCase() === buyer.buyernm.trim().toLowerCase()
        );

        if (usernameExists) {
          toaster.push(
            <Message showIcon type="warning">
              buyer name {buyer.buyernm} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
          return;
        }

        // const existingBuyer = buyerdata.find(
        //   item => item.attributes.buyernm.toLowerCase() === buyer.buyernm.toLowerCase().trim()
        // );

        // if (existingBuyer) {
        //   toaster.push(
        //     <Message showIcon type="warning">
        //       Buyer with Name {buyer.buyernm} already exists.
        //     </Message>,
        //     { placement: 'topCenter' }
        //   );
        // }
        else {
          e.preventDefault();
          const nextCategoryCode = generateNextCategoryCode();
          const formData = new FormData();
          formData.append('files.BuyerImage', buyer.BuyerImage);
          formData.append('data', JSON.stringify({ ...buyer, buyercode: nextCategoryCode }));

          const response = await fetch(buyerUrl, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            const newBuyerName = buyer.buyernm.trim();
            // 🔹 Auto-select newly added buyer
            setSelectedBuyer(newBuyerName);
            handleInputChange('BuyerName', newBuyerName, 0);
            await fetchBuyerData(); // Wait for data to be fetched before logging
            setBuyer({
              buyercode: '',
              companynm: '',
              buyernm: '',
              country: '',
              email: '',
              address: '',
              contactno: '',
              merchantnm: '',
              dis: 'Continue'
            });
            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
            handleCloseBuyerModal();
            setImageFile(null);
            setIsNewBuyerAdd(true)
          } else {
            console.error('Failed to save data');
            setIsNewBuyerAdd(false)
          }
        }
      } catch (error) {
        setIsNewBuyerAdd(false)
        console.error(error);
      }
    }
  };

  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <Stack className="table-toolbar edit-head" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start" className="edit-main">
              <Stack direction="row" alignItems="flex-start" spacing={180}>
                <h3 className="title">Catalogues</h3>
                <div onClick={() => setOpenMenu(!openMenu)}>
                  <MenuIcon className="burgerMenu1" />
                  {/* <CloseIcon className='burgerMenu1'/> */}
                </div>
              </Stack>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/selection`}>Select Product</Link>
                </Breadcrumb.Item>

                <Breadcrumb.Item active>Edit Details</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>

          <Stack
            spacing={10}
            className={openMenu ? 'mange-item' : 'mange-search'}
            style={{ marginTop: '-30px' }}
          >
            <Input
              placeholder="Search Products by Style No"
              value={searchProductId}
              style={{width:"250px"}}
              onChange={value => setSearchProductId(value)}
              onKeyDown={e => {
                if (e.key === 'Enter') fetchData(); // fetch + filter on Enter
              }}
            />
            <Stack spacing={10} className="edit-btn">
              <Button appearance="subtle" active onClick={toggleEdit}>
                {edit ? 'Cancel' : 'Edit'}
              </Button>

              <Button appearance="subtle" active onClick={handleOpenModal}>
                Add More Product
              </Button>
            </Stack>
            <Stack spacing={10} className="ctl-edit-btn">
              {(user.CATCustomizeTab === true || user.Category === 'Admin') && (
                <Button appearance="ghost" color="cyan" onClick={handleOpen}>
                  Customize Table
                </Button>
              )}
              <Dropdown
                title={updateCatalogue?.length ? 'Update' : 'Create'}
                placement="bottomEnd"
                color="cyan"
                appearance="primary"
                disabled={!isDataFetched}
                className="edit-dropdown"
              >
                {updateCatalogue?.length && (
                  <Dropdown.Item onClick={handleOpen5}>
                    <Stack spacing={80}>
                      <Stack direction="column" alignItems="flex-start">
                        <b>Update Catalogue</b>
                        <p>Update catalogue for a buyer</p>
                      </Stack>
                      <Stack>
                        <Icon as={ProjectIcon} />
                      </Stack>
                    </Stack>
                  </Dropdown.Item>
                )}
                <Dropdown.Item onClick={handleOpen1}>
                  <Stack spacing={80}>
                    <Stack direction="column" alignItems="flex-start">
                      <b>Create Catalogue</b>
                      <p>Create catalogue for a buyer</p>
                    </Stack>
                    <Stack>
                      <Icon as={ProjectIcon} />
                    </Stack>
                  </Stack>
                </Dropdown.Item>
                <Dropdown.Item onClick={handleOpen2}>
                  <Stack spacing={120}>
                    <Stack direction="column" alignItems="flex-start">
                      <b>Draft Catalogue</b>
                      <p>Draft for a verification</p>
                    </Stack>
                    <Stack>
                      <Icon as={TreemapIcon} />
                    </Stack>
                  </Stack>
                </Dropdown.Item>
                <Dropdown.Item onClick={handleOpen3}>
                  <Stack spacing={80}>
                    <Stack direction="column" alignItems="flex-start">
                      <b>Create Collection</b>
                      <p>Create collection for a buyer</p>
                    </Stack>
                    <Stack>
                      <Icon as={SendIcon} />
                    </Stack>
                  </Stack>
                </Dropdown.Item>
              </Dropdown>
              {/* <Button color="cyan" appearance="primary">
                Continue
            </Button> */}
            </Stack>
          </Stack>
        </Stack>

        <Divider className="edit-dvd" style={{ marginTop: '-20px', marginBottom: '0px' }} />
        <div>
          <Panel className="ctlg-details-pnl">
            <Table
              rowHeight={60}
              rowClassName={() => "fixed-row"}
              data={noData ? [] : paginatedData}
              height={tableHeight}
              rowKey="id"
              loading={loading}
              bordered
              cellBordered
              wordWrap="break-word"
              headerHeight={60}
              virtualized
            >

              {defaultColumns.map(column => {
                if (columnKeys.includes(column.key)) {
                  const { key, label, headerCell, cell, ...rest } = column;
                  return (
                    <Table.Column {...rest} key={key}>
                      {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                      {cell || <CustomCell dataKey={key} />}
                    </Table.Column>
                  );
                }
                return null;
              })}
            </Table>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={['total', '-', '|', 'pager', 'skip']}
              total={dataWithSerialNumbers.length}
              limit={10}
              activePage={currentPage}
              onChangePage={setCurrentPage}
              style={{ marginTop: '5px' }}
            />
          </Panel>
        </div>
        <AddRemoveProductModal
          {...{
            showModal,
            setShowModal,
            fetchData,
            modalSelectedItems,
            setModalSelectedItems,
            label
          }}
        />

        <TableCustomizeDetails
          {...{ open, handleClose, defaultColumns, columnKeys, setColumnKeys }}
        />
        <Modal open={open5} onClose={handleClose5} backdrop={'static'} size='lg'>
          <Modal.Header>
            <b>Please fill the catalogue details.</b>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Catalogue Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="catalogueName"
                      name="catalogueName"
                      value={cata && cata.catalogueName ? cata.catalogueName : ''}
                      onChange={value => handleInputChange('catalogueName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerCompany"
                      name="BuyerCompany"
                      value={cata && cata.BuyerCompany ? cata.BuyerCompany : ''}
                      onChange={value => handleInputChange('BuyerCompany', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerName"
                      name="BuyerName"
                      value={cata && cata.BuyerName ? cata.BuyerName : ''}
                      onChange={value => handleInputChange('BuyerName', value, 0)}
                      block
                      onOpen={() => fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Contact Person</Form.ControlLabel>
                    <Input
                      id="CPerson"
                      name="CPerson"
                      value={cata && cata.CPerson ? cata.CPerson : ''}
                      onChange={value => handleInputChange('CPerson', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="BuyerEmail"
                      name="BuyerEmail"
                      value={cata && cata.BuyerEmail ? cata.BuyerEmail : ''}
                      onChange={value => handleInputChange('BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={updateSubmit} appearance="primary" color="cyan" active >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal open={open1} onClose={handleClose1} backdrop={'static'} size="lg">
          <Modal.Header>
            <b>Please fill the catalogue details.</b>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Catalogue Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="catalogueName"
                      name="catalogueName"
                      value={cata && cata.catalogueName ? cata.catalogueName : ''}
                      onChange={value => handleInputChange('catalogueName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerCompany"
                      name="BuyerCompany"
                      // value={cata && cata.BuyerCompany ? cata.BuyerCompany : ''}
                      value={selectedCompany}
                      onChange={value => handleInputChange('BuyerCompany', value, 0)}
                      block
                      renderExtraFooter={() => (
                        <div
                          style={{
                            padding: 10,
                            cursor: 'pointer',
                            color: '#1675e0',
                            fontWeight: 500
                          }}
                          onClick={() => handleOpenCompModal('sm')}
                        >
                          + Add New Company
                        </div>
                      )}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerName"
                      name="BuyerName"
                      // value={cata && cata.BuyerName ? cata.BuyerName : ''}
                      value={selectedBuyer}
                      onChange={value => handleInputChange('BuyerName', value, 0)}
                      block
                      renderExtraFooter={() => (
                        <div
                          style={{
                            padding: 10,
                            cursor: 'pointer',
                            color: '#1675e0',
                            fontWeight: 500
                          }}
                          onClick={() => handleOpenBuyerModal('sm')}
                        >
                          + Add New Buyer
                        </div>
                      )}
                      onOpen={() => fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Contact Person</Form.ControlLabel>
                    <Input
                      id="CPerson"
                      name="CPerson"
                      value={cata && cata.CPerson ? cata.CPerson : ''}
                      onChange={value => handleInputChange('CPerson', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="BuyerEmail"
                      name="BuyerEmail"
                      value={cata && cata.BuyerEmail ? cata.BuyerEmail : ''}
                      onChange={value => handleInputChange('BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              <Button onClick={submitCatalogue} appearance="primary" color="cyan">
                Finish
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        {selectedRow && (
          <ShowDimensionModal {...{ showDimm, handleCloseDimm, selectedRow, finShow, label }} />
        )}
        <Modal open={showDimm2} onClose={handleCloseDimm2} size="md">
          <Modal.Header>
            <Modal.Title>Dimension</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table wordWrap data={selectedRow} cellBordered height={400} rowHeight={60} bordered>
              {/* Description column: SelectPicker */}
              <Column width={160} align="center">
                <HeaderCell>Description</HeaderCell>
                <Cell>
                  {rowData => (
                    <Input
                      value={rowData.Description}
                      rows={3} // Set the number of rows for the textarea
                      onChange={value => handleInputChange4(value, rowData, 'Description')}
                    />
                  )}
                </Cell>
              </Column>

              {/* Length column: Input */}
              <Column width={110} align="center">
                <HeaderCell>Length</HeaderCell>
                <Cell>
                  {rowData => (
                    <Input
                      type="number"
                      value={rowData.Length}
                      onChange={value => handleInputChange4(value, rowData, 'Length')}
                    />
                  )}
                </Cell>
              </Column>

              {/* Width column: Input */}
              <Column width={110} align="center">
                <HeaderCell>Width</HeaderCell>
                <Cell>
                  {rowData => (
                    <Input
                      type="number"
                      value={rowData.Width}
                      onChange={value => handleInputChange4(value, rowData, 'Width')}
                    />
                  )}
                </Cell>
              </Column>

              {/* Height column: Input */}
              <Column width={110} align="center">
                <HeaderCell>Height</HeaderCell>
                <Cell>
                  {rowData => (
                    <Input
                      type="number"
                      value={rowData.Height}
                      onChange={value => handleInputChange4(value, rowData, 'Height')}
                    />
                  )}
                </Cell>
              </Column>

              {/* Size Unit column: SelectPicker */}
              <Column width={120} align="center">
                <HeaderCell>Size Unit</HeaderCell>
                <Cell>
                  {rowData => (
                    <SelectPicker
                      data={siii}
                      defaultValue={rowData.Unit}
                      value={rowData.SizeUnit}
                      onChange={value => handleInputChange4(value, rowData, 'SizeUnit')}
                    />
                  )}
                </Cell>
              </Column>

              {/* Color column: SelectPicker */}
              <Column width={150} align="center">
                <HeaderCell>Color</HeaderCell>
                <Cell>
                  {rowData => (
                    <SelectPicker
                      data={colordata}
                      value={rowData.ColorCode}
                      onChange={value => handleInputChange4(value, rowData, 'ColorName')}
                    />
                  )}
                </Cell>
              </Column>
            </Table>
          </Modal.Body>

          <Modal.Footer>
            <Stack spacing={15} alignItems="flex-end" justifyContent="flex-end">
              <Button appearance="subtle" active onClick={saveDimmChange}>
                Save
              </Button>
              <Button appearance="primary" color="cyan" onClick={handleCloseDimm2}>
                Cancel
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        <Modal open={open2} onClose={handleClose2} backdrop={'static'} size="lg">
          <Modal.Header>
            <b>Please fill the draft details.</b>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Catalogue Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="catalogueName"
                      name="catalogueName"
                      value={cata && cata.catalogueName ? cata.catalogueName : ''}
                      onChange={value => handleInputChange('catalogueName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerCompany"
                      name="BuyerCompany"
                      value={cata && cata.BuyerCompany ? cata.BuyerCompany : ''}
                      onChange={value => handleInputChange('BuyerCompany', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerName"
                      name="BuyerName"
                      value={cata && cata.BuyerName ? cata.BuyerName : ''}
                      onChange={value => handleInputChange('BuyerName', value, 0)}
                      block
                      onOpen={() => fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="BuyerEmail"
                      name="BuyerEmail"
                      value={cata && cata.BuyerEmail ? cata.BuyerEmail : ''}
                      onChange={value => handleInputChange('BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              <Button onClick={datattt2} appearance="primary" color="cyan">
                Finish
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        <Modal open={open4} onClose={handleClose4} backdrop="static">
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>Saved Successfully</b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Stack spacing={15} alignItems="flex-end" justifyContent="flex-end">
              <Link to={`/${ugr}/manageCatalogue`}>
                <Button appearance="subtle" active>
                  Manage Catalogue
                </Button>
              </Link>
              <Link to={`/${ugr}/selection`}>
                <Button appearance="primary" color="cyan">
                  Ok
                </Button>
              </Link>
            </Stack>
          </Modal.Footer>
        </Modal>
        <Modal open={open3} onClose={handleClose3} backdrop={'static'} size="lg">
          <Modal.Header>
            <Modal.Title>
              <b>Please fill the details.</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Collection Name </p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="CollectionName"
                      name="CollectionName"
                      value={coll && coll.CollectionName ? coll.CollectionName : ''}
                      onChange={value => handleInputChangec('CollectionName', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <SelectPicker
                      data={companydataa}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerCompany"
                      name="BuyerCompany"
                      value={coll && coll.BuyerCompany ? coll.BuyerCompany : ''}
                      onChange={value => handleInputChangec('BuyerCompany', value, 0)}
                      block
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                    <SelectPicker
                      data={filteredBuyerData}
                      labelKey="label"
                      valueKey="value"
                      id="BuyerName"
                      name="BuyerName"
                      value={coll && coll.BuyerName ? coll.BuyerName : ''}
                      onChange={value => handleInputChangec('BuyerName', value, 0)}
                      block
                      onOpen={() => fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Input
                      id="BuyerEmail"
                      name="BuyerEmail"
                      value={coll && coll.BuyerEmail ? coll.BuyerEmail : ''}
                      onChange={value => handleInputChangec('BuyerEmail', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end">
              <Button onClick={createCollection} appearance="primary" color="cyan">
                Finish
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        <Modal size="full" open={opencbm} onClose={handleClosecbm} backdrop="static">
          <Modal.Body>
            <Panel header="Packaging">
              <div>
                <Form fluid>
                  <FlexboxGrid justify="space-between">
                    <FlexboxGrid.Item as={Col} colspan={24} md={22}>
                      {data5.Packaging.map((packaging, index) => (
                        <div key={index}>
                          <FlexboxGrid justify="space-around" style={{ marginBottom: '10px' }}>
                            <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                              <Form.ControlLabel>Carton Type</Form.ControlLabel>
                              <InputPicker
                                data={cartontype}
                                name={`CartonType_${index}`}
                                value={packaging.CartonType}
                                cleanable={false}
                                onChange={event =>
                                  handleInputChange1(`CartonType_${index}`, event, index)
                                }
                              />
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                              <Form.ControlLabel>SizeUnit</Form.ControlLabel>
                              <InputPicker
                                data={siii}
                                name={`Carton_Unit_${index}`}
                                value={packaging.Carton_Unit || 'inch'}
                                cleanable={false}
                                onChange={event =>
                                  handleInputChange1(`Carton_Unit_${index}`, event, index)
                                }
                              />
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                              <Form.ControlLabel>Length</Form.ControlLabel>
                              <InputNumber
                                name={`Carton_Length_${index}`}
                                value={packaging.Carton_Length}
                                onChange={event =>
                                  handleInputChange1(`Carton_Length_${index}`, event, index)
                                }
                                min={0}
                              />
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                              <Form.ControlLabel>Width</Form.ControlLabel>
                              <InputNumber
                                name={`Carton_Width_${index}`}
                                value={packaging.Carton_Width}
                                onChange={event =>
                                  handleInputChange1(`Carton_Width_${index}`, event, index)
                                }
                                min={0}
                              />
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                              <Form.ControlLabel>Height</Form.ControlLabel>
                              <InputNumber
                                name={`Carton_Thick_${index}`}
                                value={packaging.Carton_Thick}
                                onChange={event =>
                                  handleInputChange1(`Carton_Thick_${index}`, event, index)
                                }
                                min={0}
                              />
                            </FlexboxGrid.Item>

                            <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                              <Form.ControlLabel>Box Area</Form.ControlLabel>
                              <Input
                                readOnly
                                name={`Perpc_${index}`}
                                value={packaging.Carton_CBMperpc}
                                onChange={event =>
                                  handleInputChange1(`Perpc_${index}`, event, index)
                                }
                              />
                            </FlexboxGrid.Item>

                            <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                              <Form.ControlLabel>PCS</Form.ControlLabel>
                              <InputNumber
                                min={0}
                                name={`Carton_PCS_${index}`}
                                value={packaging.Carton_PCS}
                                onChange={event =>
                                  handleInputChange1(`Carton_PCS_${index}`, event, index)
                                }
                              />
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                              <Form.ControlLabel>CBM</Form.ControlLabel>
                              <Input
                                readOnly
                                name={`Carton_CBM_${index}`}
                                value={packaging.Carton_CBM}
                                onChange={event =>
                                  handleInputChange1(`Carton_CBM_${index}`, event, index)
                                }
                              />
                            </FlexboxGrid.Item>

                            <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                              <Form.ControlLabel>Gross Wt.</Form.ControlLabel>
                              <InputNumber
                                name={`Carton_GrsWt_${index}`}
                                value={packaging.Carton_GrsWt}
                                onChange={event =>
                                  handleInputChange1(`Carton_GrsWt_${index}`, event, index)
                                }
                                min={0}
                              />
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={1}>
                              {index > 0 && (
                                <IconButton
                                  active
                                  style={{ marginTop: '20px' }}
                                  onClick={() => deletePackege(index)}
                                  icon={<TrashIcon />}
                                />
                              )}
                            </FlexboxGrid.Item>
                          </FlexboxGrid>
                        </div>
                      ))}
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                      <Button active onClick={addPackaging} style={{ marginTop: '20px' }}>
                        Add Row
                      </Button>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </Form>
              </div>
            </Panel>
            <Panel header="Loadability">
              <Form fluid>
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <Form.Group controlId="name-1">
                      <Form.ControlLabel>Total CBM</Form.ControlLabel>
                      <InputNumber id="Total_CBM" name="Total_CBM" value={totalcbm1} readOnly />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <Form.Group controlId="name-1">
                      <Form.ControlLabel>Total CFT</Form.ControlLabel>
                      <InputNumber id="Total_CFT" name="Total_CFT" value={totalcft} readOnly />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <Form.Group controlId="name-1">
                      <Form.ControlLabel>20FT</Form.ControlLabel>
                      <Input id="TwentyFT" name="TwentyFT" value={feet20} readOnly />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <Form.Group controlId="name-1">
                      <Form.ControlLabel>40FT</Form.ControlLabel>
                      <Input id="FortyFT" name="FortyFT" value={feet40} readOnly />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                    <Form.Group controlId="name-1">
                      <Form.ControlLabel>40HQ</Form.ControlLabel>
                      <Input id="FortyHQ" name="FortyHQ" value={feet20hc} readOnly />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </Form>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClosecbm} appearance="default" active>
              Cancel
            </Button>
            <Button onClick={submitpack} appearance="primary" color="cyan">
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal backdrop="static" role="alertdialog" open={openmaster} size="xs">
          <Modal.Body>
            <RemindIcon style={{ color: '#ffb300', fontSize: 24 }} />
            Do you also want to save updated data in Master ?
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClosemasterYes} appearance="primary" loading={loadingMaster}>
              Yes
            </Button>
            <Button onClick={handleClosemasterNo} appearance="subtle" active>
              No
            </Button>
          </Modal.Footer>
        </Modal>
        {/* add buyer compnay modal  */}
        <Modal size={size1} open={openCompModal} onClose={handleCloseCompModal}>
          <Modal.Header>
            <Modal.Title>
              <b>Add Buyer Company</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Stack spacing={10} style={{ marginBottom: '20px' }} >
              <Input
                id="companynm"
                name="companynm"
                value={company && company.companynm ? company.companynm : ''}
                onChange={value => handleInputChange('companynm', value, 0)}
                onPressEnter={submitCompany}
              />
              <Button onClick={submitCompany} appearance="primary" color="cyan" active>
                Add
              </Button>
            </Stack>
            {/* <Table height={380} data={companydata} bordered cellBordered rowHeight={40} rowKey="id">
            <Column width={80} align="center">
              <HeaderCell>Sr. No.</HeaderCell>
              <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
            </Column>

            <Column align="center" width={360}>
              <HeaderCell>Buyer Company Name</HeaderCell>
              <Cell>
                {rowData =>
                  editedRowIdscompany.includes(rowData.id) ? (
                    <Input
                      style={{ marginTop: '-8px' }}
                      size="xs"
                      value={editedDatacompany[rowData.id]?.companynm || ''}
                      onChange={value => handleInputChangecompany(rowData.id, 'companynm', value)}
                    />
                  ) : (
                    <p style={{ marginTop: '-8px' }}>{rowData.attributes.companynm}</p>
                  )
                }
              </Cell>
            </Column>

            <Column align="center" width={100}>
              <HeaderCell>Action</HeaderCell>
              <Cell>
                {rowData =>
                  editedRowIdscompany.includes(rowData.id) ? (
                    <div>
                      <IconButton
                        size="xs"
                        icon={<CheckIcon />}
                        active
                        onClick={() => handleSaveRowcompany(rowData.id)}
                        disabled={
                          !editedDatacompany[rowData.id]?.companynm ||
                          editedDatacompany[rowData.id]?.companynm.trim() === '' ||
                          companydata.some(
                            item =>
                              item.attributes.companynm.toLowerCase() ===
                              editedDatacompany[rowData.id]?.companynm.toLowerCase() &&
                              item.id !== rowData.id
                          )
                        }
                        style={{ marginRight: '10px', marginTop: '-10px' }}
                      />
                      <IconButton
                        size="xs"
                        icon={<CloseIcon />}
                        active
                        onClick={() =>
                          setEditedRowIdscompany(prevRowIds =>
                            prevRowIds.filter(id => id !== rowData.id)
                          )
                        }
                        style={{ marginTop: '-10px' }}
                      />
                    </div>
                  ) : (
                    <div>
                      <IconButton
                        size="xs"
                        icon={<EditIcon />}
                        active
                        onClick={() => handleEditRowcompany(rowData)}
                        style={{ marginTop: '-10px' }}
                      />
                      {rowData.attributes.dis === 'Discontinue' ? (
                        // Render Discontinue button
                        <Whisper speaker={<Tooltip>Continue</Tooltip>}>
                          <IconButton
                            size="xs"
                            icon={<ReviewRefuseIcon />}
                            active
                            style={{ marginLeft: '10px', marginTop: '-10px' }}
                            onClick={() => handleBuyerC(rowData.id, rowData.attributes.companynm)}
                          />
                        </Whisper>
                      ) : (
                        // Render Continue button
                        <Whisper speaker={<Tooltip>Discontinue</Tooltip>}>
                          <IconButton
                            size="xs"
                            icon={<ReviewPassIcon />}
                            active
                            style={{ marginLeft: '10px', marginTop: '-10px' }}
                            onClick={() => handleBuyerD(rowData.id, rowData.attributes.companynm)}
                          />
                        </Whisper>
                      )}
                    </div>
                  )
                }
              </Cell>
            </Column>
          </Table> */}
          </Modal.Body>
        </Modal>
        {/* add buyer modal  */}
        <Modal size={buyerModalsize} open={openBuyerModal} onClose={handleCloseBuyerModal} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Add Buyer</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form fluid>
              <FlexboxGrid justify="start">
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Buyer Company Name</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <SelectPicker
                      id="companynm"
                      name="companynm"
                      size="md"
                      data={companydataa}
                      value={buyer && buyer.companynm ? buyer.companynm : ''}
                      onChange={value => handleInputChange('companynm', value, 0)}
                      labelKey="label"
                      valueKey="value"
                      block
                      onOpen={fetchData6}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Buyer Name</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      placeholder="Buyer Name"
                      id="buyernm"
                      name="buyernm"
                      value={buyer && buyer.buyernm ? buyer.buyernm : ''}
                      onChange={value => handleInputChange('buyernm', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Country</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <SelectPicker
                      data={countrydata}
                      id="country"
                      name="country"
                      block
                      size="md"
                      value={buyer && buyer.country ? buyer.country : ''}
                      onChange={value => handleInputChange('country', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>Email<p style={{ color: 'red' }}>*</p></Stack>
                    </Form.ControlLabel>
                    <Input
                      id="email"
                      name="email"
                      placeholder='Email'
                      value={buyer && buyer.email ? buyer.email : ''}
                      onChange={value => handleInputChange('email', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Address</Form.ControlLabel>
                    <Input
                      id="address"
                      name="address"
                      value={buyer && buyer.address ? buyer.address : ''}
                      onChange={value => handleInputChange('address', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Contact No.</p>
                        {/* <p style={{ color: 'red' }}>*</p> */}
                      </Stack>
                    </Form.ControlLabel>
                    <InputNumber
                      step={null}
                      id="contactno"
                      name="contactno"
                      value={buyer && buyer.contactno ? buyer.contactno : ''}
                      onChange={value => handleInputChange('contactno', value, 0)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Merchant</Form.ControlLabel>
                    <SelectPicker
                      id="merchantnm"
                      name="merchantnm"
                      size="md"
                      data={merchant}
                      value={buyer && buyer.merchantnm ? buyer.merchantnm : ''}
                      onChange={value => handleInputChange('merchantnm', value, 0)}
                      labelKey="label"
                      valueKey="value"
                      block
                      onOpen={fetchDatamar}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Add Buyer Image</Form.ControlLabel>
                    <Stack>
                      {/* <Uploader
                                style={{ display: 'flex', gap: '20px' }}
                                active
                                listType="picture-text"
                                renderFileInfo={(file, fileElement) => {
                                  return (
                                    <>
                                      <span>File Name: {file.name}</span>
                                      <p>File URL: {file.url}</p>
                                    </>
                                  );
                                }}
                                onChange={handleImageUpload}
                                action={''}
                              >
                                <Button>Upload Image</Button>
                              </Uploader> */}
                      <Button onClick={handleButtonClick} appearance="default" active>
                        <ImageIcon /> Upload Image
                      </Button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        accept=".jpg, .jpeg"
                        onChange={handleFileChange}
                        style={{ display: 'none' }} // Hide the default file input
                      />
                      {buyer.BuyerImage && (
                        <img
                          src={imageFile}
                          alt="Uploaded"
                          style={{ width: '36px', height: '36px', marginLeft: '10px' }}
                        />
                      )}
                    </Stack>
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end" spacing={10}>
              <Button onClick={handleCloseBuyerModal} appearance="subtle" active>
                Cancel
              </Button>
              <Button onClick={submitBuyer} appearance="primary" color="cyan">
                Add
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        <Footer />
        <DrawerViewe open={showDrawer3} onClose={() => setShowDrawer3(false)} />
        <DrawerLink open={showDrawer2} onClose={() => setShowDrawer2(false)} />
      </Container>
    </>
  );
};

export default EditDetails;
